var Bt = Object.defineProperty, Vt = (t, e, n) => e in t ? Bt(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, ft = (t, e, n) => Vt(t, typeof e != "symbol" ? e + "" : e, n);
class Be extends Error {
  constructor(e, n) {
    super(e), ft(this, "code"), this.name = "HeError", this.code = n;
  }
}
function dt(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: Mt } = Object.prototype, { getPrototypeOf: Ne } = Object, pe = /* @__PURE__ */ ((t) => (e) => {
  const n = Mt.call(e);
  return t[n] || (t[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), C = (t) => (t = t.toLowerCase(), (e) => pe(e) === t), he = (t) => (e) => typeof e === t, { isArray: H } = Array, X = he("undefined");
function Ht(t) {
  return t !== null && !X(t) && t.constructor !== null && !X(t.constructor) && P(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const pt = C("ArrayBuffer");
function Kt(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && pt(t.buffer), e;
}
const qt = he("string"), P = he("function"), ht = he("number"), ge = (t) => t !== null && typeof t == "object", Jt = (t) => t === !0 || t === !1, ae = (t) => {
  if (pe(t) !== "object")
    return !1;
  const e = Ne(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}, Gt = C("Date"), Wt = C("File"), Zt = C("Blob"), Yt = C("FileList"), Qt = (t) => ge(t) && P(t.pipe), Xt = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || P(t.append) && ((e = pe(t)) === "formdata" || // detect form-data instance
  e === "object" && P(t.toString) && t.toString() === "[object FormData]"));
}, en = C("URLSearchParams"), [tn, nn, rn, on] = ["ReadableStream", "Request", "Response", "Headers"].map(C), an = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function te(t, e, { allOwnKeys: n = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let r, o;
  if (typeof t != "object" && (t = [t]), H(t))
    for (r = 0, o = t.length; r < o; r++)
      e.call(null, t[r], r, t);
  else {
    const a = n ? Object.getOwnPropertyNames(t) : Object.keys(t), s = a.length;
    let i;
    for (r = 0; r < s; r++)
      i = a[r], e.call(null, t[i], i, t);
  }
}
function gt(t, e) {
  e = e.toLowerCase();
  const n = Object.keys(t);
  let r = n.length, o;
  for (; r-- > 0; )
    if (o = n[r], e === o.toLowerCase())
      return o;
  return null;
}
const U = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, mt = (t) => !X(t) && t !== U;
function Oe() {
  const { caseless: t } = mt(this) && this || {}, e = {}, n = (r, o) => {
    const a = t && gt(e, o) || o;
    ae(e[a]) && ae(r) ? e[a] = Oe(e[a], r) : ae(r) ? e[a] = Oe({}, r) : H(r) ? e[a] = r.slice() : e[a] = r;
  };
  for (let r = 0, o = arguments.length; r < o; r++)
    arguments[r] && te(arguments[r], n);
  return e;
}
const sn = (t, e, n, { allOwnKeys: r } = {}) => (te(e, (o, a) => {
  n && P(o) ? t[a] = dt(o, n) : t[a] = o;
}, { allOwnKeys: r }), t), ln = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), cn = (t, e, n, r) => {
  t.prototype = Object.create(e.prototype, r), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), n && Object.assign(t.prototype, n);
}, un = (t, e, n, r) => {
  let o, a, s;
  const i = {};
  if (e = e || {}, t == null) return e;
  do {
    for (o = Object.getOwnPropertyNames(t), a = o.length; a-- > 0; )
      s = o[a], (!r || r(s, t, e)) && !i[s] && (e[s] = t[s], i[s] = !0);
    t = n !== !1 && Ne(t);
  } while (t && (!n || n(t, e)) && t !== Object.prototype);
  return e;
}, fn = (t, e, n) => {
  t = String(t), (n === void 0 || n > t.length) && (n = t.length), n -= e.length;
  const r = t.indexOf(e, n);
  return r !== -1 && r === n;
}, dn = (t) => {
  if (!t) return null;
  if (H(t)) return t;
  let e = t.length;
  if (!ht(e)) return null;
  const n = new Array(e);
  for (; e-- > 0; )
    n[e] = t[e];
  return n;
}, pn = /* @__PURE__ */ ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && Ne(Uint8Array)), hn = (t, e) => {
  const n = (t && t[Symbol.iterator]).call(t);
  let r;
  for (; (r = n.next()) && !r.done; ) {
    const o = r.value;
    e.call(t, o[0], o[1]);
  }
}, gn = (t, e) => {
  let n;
  const r = [];
  for (; (n = t.exec(e)) !== null; )
    r.push(n);
  return r;
}, mn = C("HTMLFormElement"), _n = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(e, n, r) {
    return n.toUpperCase() + r;
  }
), Ve = (({ hasOwnProperty: t }) => (e, n) => t.call(e, n))(Object.prototype), bn = C("RegExp"), _t = (t, e) => {
  const n = Object.getOwnPropertyDescriptors(t), r = {};
  te(n, (o, a) => {
    let s;
    (s = e(o, a, t)) !== !1 && (r[a] = s || o);
  }), Object.defineProperties(t, r);
}, yn = (t) => {
  _t(t, (e, n) => {
    if (P(t) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = t[n];
    if (P(r)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, vn = (t, e) => {
  const n = {}, r = (o) => {
    o.forEach((a) => {
      n[a] = !0;
    });
  };
  return H(t) ? r(t) : r(String(t).split(e)), n;
}, wn = () => {
}, xn = (t, e) => t != null && Number.isFinite(t = +t) ? t : e, ve = "abcdefghijklmnopqrstuvwxyz", Me = "0123456789", bt = {
  DIGIT: Me,
  ALPHA: ve,
  ALPHA_DIGIT: ve + ve.toUpperCase() + Me
}, Sn = (t = 16, e = bt.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = e;
  for (; t--; )
    n += e[Math.random() * r | 0];
  return n;
};
function kn(t) {
  return !!(t && P(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator]);
}
const On = (t) => {
  const e = new Array(10), n = (r, o) => {
    if (ge(r)) {
      if (e.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        e[o] = r;
        const a = H(r) ? [] : {};
        return te(r, (s, i) => {
          const l = n(s, o + 1);
          !X(l) && (a[i] = l);
        }), e[o] = void 0, a;
      }
    }
    return r;
  };
  return n(t, 0);
}, Rn = C("AsyncFunction"), En = (t) => t && (ge(t) || P(t)) && P(t.then) && P(t.catch), yt = ((t, e) => t ? setImmediate : e ? ((n, r) => (U.addEventListener("message", ({ source: o, data: a }) => {
  o === U && a === n && r.length && r.shift()();
}, !1), (o) => {
  r.push(o), U.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  P(U.postMessage)
), $n = typeof queueMicrotask < "u" ? queueMicrotask.bind(U) : typeof process < "u" && process.nextTick || yt, d = {
  isArray: H,
  isArrayBuffer: pt,
  isBuffer: Ht,
  isFormData: Xt,
  isArrayBufferView: Kt,
  isString: qt,
  isNumber: ht,
  isBoolean: Jt,
  isObject: ge,
  isPlainObject: ae,
  isReadableStream: tn,
  isRequest: nn,
  isResponse: rn,
  isHeaders: on,
  isUndefined: X,
  isDate: Gt,
  isFile: Wt,
  isBlob: Zt,
  isRegExp: bn,
  isFunction: P,
  isStream: Qt,
  isURLSearchParams: en,
  isTypedArray: pn,
  isFileList: Yt,
  forEach: te,
  merge: Oe,
  extend: sn,
  trim: an,
  stripBOM: ln,
  inherits: cn,
  toFlatObject: un,
  kindOf: pe,
  kindOfTest: C,
  endsWith: fn,
  toArray: dn,
  forEachEntry: hn,
  matchAll: gn,
  isHTMLForm: mn,
  hasOwnProperty: Ve,
  hasOwnProp: Ve,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: _t,
  freezeMethods: yn,
  toObjectSet: vn,
  toCamelCase: _n,
  noop: wn,
  toFiniteNumber: xn,
  findKey: gt,
  global: U,
  isContextDefined: mt,
  ALPHABET: bt,
  generateString: Sn,
  isSpecCompliantForm: kn,
  toJSONObject: On,
  isAsyncFn: Rn,
  isThenable: En,
  setImmediate: yt,
  asap: $n
};
function b(t, e, n, r, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), n && (this.config = n), r && (this.request = r), o && (this.response = o, this.status = o.status ? o.status : null);
}
d.inherits(b, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: d.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const vt = b.prototype, wt = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  wt[t] = { value: t };
});
Object.defineProperties(b, wt);
Object.defineProperty(vt, "isAxiosError", { value: !0 });
b.from = (t, e, n, r, o, a) => {
  const s = Object.create(vt);
  return d.toFlatObject(t, s, function(i) {
    return i !== Error.prototype;
  }, (i) => i !== "isAxiosError"), b.call(s, t.message, e, n, r, o), s.cause = t, s.name = t.name, a && Object.assign(s, a), s;
};
const jn = null;
function Re(t) {
  return d.isPlainObject(t) || d.isArray(t);
}
function xt(t) {
  return d.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function He(t, e, n) {
  return t ? t.concat(e).map(function(r, o) {
    return r = xt(r), !n && o ? "[" + r + "]" : r;
  }).join(n ? "." : "") : e;
}
function Pn(t) {
  return d.isArray(t) && !t.some(Re);
}
const An = d.toFlatObject(d, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function me(t, e, n) {
  if (!d.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), n = d.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(h, m) {
    return !d.isUndefined(m[h]);
  });
  const r = n.metaTokens, o = n.visitor || c, a = n.dots, s = n.indexes, i = (n.Blob || typeof Blob < "u" && Blob) && d.isSpecCompliantForm(e);
  if (!d.isFunction(o))
    throw new TypeError("visitor must be a function");
  function l(h) {
    if (h === null) return "";
    if (d.isDate(h))
      return h.toISOString();
    if (!i && d.isBlob(h))
      throw new b("Blob is not supported. Use a Buffer instead.");
    return d.isArrayBuffer(h) || d.isTypedArray(h) ? i && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function c(h, m, g) {
    let _ = h;
    if (h && !g && typeof h == "object") {
      if (d.endsWith(m, "{}"))
        m = r ? m : m.slice(0, -2), h = JSON.stringify(h);
      else if (d.isArray(h) && Pn(h) || (d.isFileList(h) || d.endsWith(m, "[]")) && (_ = d.toArray(h)))
        return m = xt(m), _.forEach(function(w, y) {
          !(d.isUndefined(w) || w === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? He([m], y, a) : s === null ? m : m + "[]",
            l(w)
          );
        }), !1;
    }
    return Re(h) ? !0 : (e.append(He(g, m, a), l(h)), !1);
  }
  const u = [], p = Object.assign(An, {
    defaultVisitor: c,
    convertValue: l,
    isVisitable: Re
  });
  function f(h, m) {
    if (!d.isUndefined(h)) {
      if (u.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      u.push(h), d.forEach(h, function(g, _) {
        (!(d.isUndefined(g) || g === null) && o.call(
          e,
          g,
          d.isString(_) ? _.trim() : _,
          m,
          p
        )) === !0 && f(g, m ? m.concat(_) : [_]);
      }), u.pop();
    }
  }
  if (!d.isObject(t))
    throw new TypeError("data must be an object");
  return f(t), e;
}
function Ke(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(n) {
    return e[n];
  });
}
function Te(t, e) {
  this._pairs = [], t && me(t, this, e);
}
const St = Te.prototype;
St.append = function(t, e) {
  this._pairs.push([t, e]);
};
St.toString = function(t) {
  const e = t ? function(n) {
    return t.call(this, n, Ke);
  } : Ke;
  return this._pairs.map(function(n) {
    return e(n[0]) + "=" + e(n[1]);
  }, "").join("&");
};
function Ln(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function kt(t, e, n) {
  if (!e)
    return t;
  const r = n && n.encode || Ln, o = n && n.serialize;
  let a;
  if (o ? a = o(e, n) : a = d.isURLSearchParams(e) ? e.toString() : new Te(e, n).toString(r), a) {
    const s = t.indexOf("#");
    s !== -1 && (t = t.slice(0, s)), t += (t.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return t;
}
class qe {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, n, r) {
    return this.handlers.push({
      fulfilled: e,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    d.forEach(this.handlers, function(n) {
      n !== null && e(n);
    });
  }
}
const Ot = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Cn = typeof URLSearchParams < "u" ? URLSearchParams : Te, Nn = typeof FormData < "u" ? FormData : null, Tn = typeof Blob < "u" ? Blob : null, Dn = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Cn,
    FormData: Nn,
    Blob: Tn
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, De = typeof window < "u" && typeof document < "u", Ee = typeof navigator == "object" && navigator || void 0, Fn = De && (!Ee || ["ReactNative", "NativeScript", "NS"].indexOf(Ee.product) < 0), In = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Un = De && window.location.href || "http://localhost", zn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: De,
  hasStandardBrowserEnv: Fn,
  hasStandardBrowserWebWorkerEnv: In,
  navigator: Ee,
  origin: Un
}, Symbol.toStringTag, { value: "Module" })), A = {
  ...zn,
  ...Dn
};
function Bn(t, e) {
  return me(t, new A.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, o, a) {
      return A.isNode && d.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function Vn(t) {
  return d.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function Mn(t) {
  const e = {}, n = Object.keys(t);
  let r;
  const o = n.length;
  let a;
  for (r = 0; r < o; r++)
    a = n[r], e[a] = t[a];
  return e;
}
function Rt(t) {
  function e(n, r, o, a) {
    let s = n[a++];
    if (s === "__proto__") return !0;
    const i = Number.isFinite(+s), l = a >= n.length;
    return s = !s && d.isArray(o) ? o.length : s, l ? (d.hasOwnProp(o, s) ? o[s] = [o[s], r] : o[s] = r, !i) : ((!o[s] || !d.isObject(o[s])) && (o[s] = []), e(n, r, o[s], a) && d.isArray(o[s]) && (o[s] = Mn(o[s])), !i);
  }
  if (d.isFormData(t) && d.isFunction(t.entries)) {
    const n = {};
    return d.forEachEntry(t, (r, o) => {
      e(Vn(r), o, n, 0);
    }), n;
  }
  return null;
}
function Hn(t, e, n) {
  if (d.isString(t))
    try {
      return (e || JSON.parse)(t), d.trim(t);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (0, JSON.stringify)(t);
}
const ne = {
  transitional: Ot,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, e) {
    const n = e.getContentType() || "", r = n.indexOf("application/json") > -1, o = d.isObject(t);
    if (o && d.isHTMLForm(t) && (t = new FormData(t)), d.isFormData(t))
      return r ? JSON.stringify(Rt(t)) : t;
    if (d.isArrayBuffer(t) || d.isBuffer(t) || d.isStream(t) || d.isFile(t) || d.isBlob(t) || d.isReadableStream(t))
      return t;
    if (d.isArrayBufferView(t))
      return t.buffer;
    if (d.isURLSearchParams(t))
      return e.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let a;
    if (o) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return Bn(t, this.formSerializer).toString();
      if ((a = d.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const s = this.env && this.env.FormData;
        return me(
          a ? { "files[]": t } : t,
          s && new s(),
          this.formSerializer
        );
      }
    }
    return o || r ? (e.setContentType("application/json", !1), Hn(t)) : t;
  }],
  transformResponse: [function(t) {
    const e = this.transitional || ne.transitional, n = e && e.forcedJSONParsing, r = this.responseType === "json";
    if (d.isResponse(t) || d.isReadableStream(t))
      return t;
    if (t && d.isString(t) && (n && !this.responseType || r)) {
      const o = !(e && e.silentJSONParsing) && r;
      try {
        return JSON.parse(t);
      } catch (a) {
        if (o)
          throw a.name === "SyntaxError" ? b.from(a, b.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: A.classes.FormData,
    Blob: A.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
d.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  ne.headers[t] = {};
});
const Kn = d.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), qn = (t) => {
  const e = {};
  let n, r, o;
  return t && t.split(`
`).forEach(function(a) {
    o = a.indexOf(":"), n = a.substring(0, o).trim().toLowerCase(), r = a.substring(o + 1).trim(), !(!n || e[n] && Kn[n]) && (n === "set-cookie" ? e[n] ? e[n].push(r) : e[n] = [r] : e[n] = e[n] ? e[n] + ", " + r : r);
  }), e;
}, Je = Symbol("internals");
function Z(t) {
  return t && String(t).trim().toLowerCase();
}
function se(t) {
  return t === !1 || t == null ? t : d.isArray(t) ? t.map(se) : String(t);
}
function Jn(t) {
  const e = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(t); )
    e[r[1]] = r[2];
  return e;
}
const Gn = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function we(t, e, n, r, o) {
  if (d.isFunction(r))
    return r.call(this, e, n);
  if (o && (e = n), !!d.isString(e)) {
    if (d.isString(r))
      return e.indexOf(r) !== -1;
    if (d.isRegExp(r))
      return r.test(e);
  }
}
function Wn(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, n, r) => n.toUpperCase() + r);
}
function Zn(t, e) {
  const n = d.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(t, r + n, {
      value: function(o, a, s) {
        return this[r].call(this, e, o, a, s);
      },
      configurable: !0
    });
  });
}
let E = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, e, n) {
    const r = this;
    function o(s, i, l) {
      const c = Z(i);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const u = d.findKey(r, c);
      (!u || r[u] === void 0 || l === !0 || l === void 0 && r[u] !== !1) && (r[u || i] = se(s));
    }
    const a = (s, i) => d.forEach(s, (l, c) => o(l, c, i));
    if (d.isPlainObject(t) || t instanceof this.constructor)
      a(t, e);
    else if (d.isString(t) && (t = t.trim()) && !Gn(t))
      a(qn(t), e);
    else if (d.isHeaders(t))
      for (const [s, i] of t.entries())
        o(i, s, n);
    else
      t != null && o(e, t, n);
    return this;
  }
  get(t, e) {
    if (t = Z(t), t) {
      const n = d.findKey(this, t);
      if (n) {
        const r = this[n];
        if (!e)
          return r;
        if (e === !0)
          return Jn(r);
        if (d.isFunction(e))
          return e.call(this, r, n);
        if (d.isRegExp(e))
          return e.exec(r);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, e) {
    if (t = Z(t), t) {
      const n = d.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!e || we(this, this[n], n, e)));
    }
    return !1;
  }
  delete(t, e) {
    const n = this;
    let r = !1;
    function o(a) {
      if (a = Z(a), a) {
        const s = d.findKey(n, a);
        s && (!e || we(n, n[s], s, e)) && (delete n[s], r = !0);
      }
    }
    return d.isArray(t) ? t.forEach(o) : o(t), r;
  }
  clear(t) {
    const e = Object.keys(this);
    let n = e.length, r = !1;
    for (; n--; ) {
      const o = e[n];
      (!t || we(this, this[o], o, t, !0)) && (delete this[o], r = !0);
    }
    return r;
  }
  normalize(t) {
    const e = this, n = {};
    return d.forEach(this, (r, o) => {
      const a = d.findKey(n, o);
      if (a) {
        e[a] = se(r), delete e[o];
        return;
      }
      const s = t ? Wn(o) : String(o).trim();
      s !== o && delete e[o], e[s] = se(r), n[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const e = /* @__PURE__ */ Object.create(null);
    return d.forEach(this, (n, r) => {
      n != null && n !== !1 && (e[r] = t && d.isArray(n) ? n.join(", ") : n);
    }), e;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, e]) => t + ": " + e).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...e) {
    const n = new this(t);
    return e.forEach((r) => n.set(r)), n;
  }
  static accessor(t) {
    const e = (this[Je] = this[Je] = {
      accessors: {}
    }).accessors, n = this.prototype;
    function r(o) {
      const a = Z(o);
      e[a] || (Zn(n, o), e[a] = !0);
    }
    return d.isArray(t) ? t.forEach(r) : r(t), this;
  }
};
E.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
d.reduceDescriptors(E.prototype, ({ value: t }, e) => {
  let n = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(r) {
      this[n] = r;
    }
  };
});
d.freezeMethods(E);
function xe(t, e) {
  const n = this || ne, r = e || n, o = E.from(r.headers);
  let a = r.data;
  return d.forEach(t, function(s) {
    a = s.call(n, a, o.normalize(), e ? e.status : void 0);
  }), o.normalize(), a;
}
function Et(t) {
  return !!(t && t.__CANCEL__);
}
function K(t, e, n) {
  b.call(this, t ?? "canceled", b.ERR_CANCELED, e, n), this.name = "CanceledError";
}
d.inherits(K, b, {
  __CANCEL__: !0
});
function $t(t, e, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? t(n) : e(new b(
    "Request failed with status code " + n.status,
    [b.ERR_BAD_REQUEST, b.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function Yn(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function Qn(t, e) {
  t = t || 10;
  const n = new Array(t), r = new Array(t);
  let o = 0, a = 0, s;
  return e = e !== void 0 ? e : 1e3, function(i) {
    const l = Date.now(), c = r[a];
    s || (s = l), n[o] = i, r[o] = l;
    let u = a, p = 0;
    for (; u !== o; )
      p += n[u++], u = u % t;
    if (o = (o + 1) % t, o === a && (a = (a + 1) % t), l - s < e)
      return;
    const f = c && l - c;
    return f ? Math.round(p * 1e3 / f) : void 0;
  };
}
function Xn(t, e) {
  let n = 0, r = 1e3 / e, o, a;
  const s = (i, l = Date.now()) => {
    n = l, o = null, a && (clearTimeout(a), a = null), t.apply(null, i);
  };
  return [(...i) => {
    const l = Date.now(), c = l - n;
    c >= r ? s(i, l) : (o = i, a || (a = setTimeout(() => {
      a = null, s(o);
    }, r - c)));
  }, () => o && s(o)];
}
const ie = (t, e, n = 3) => {
  let r = 0;
  const o = Qn(50, 250);
  return Xn((a) => {
    const s = a.loaded, i = a.lengthComputable ? a.total : void 0, l = s - r, c = o(l), u = s <= i;
    r = s;
    const p = {
      loaded: s,
      total: i,
      progress: i ? s / i : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && i && u ? (i - s) / c : void 0,
      event: a,
      lengthComputable: i != null,
      [e ? "download" : "upload"]: !0
    };
    t(p);
  }, n);
}, Ge = (t, e) => {
  const n = t != null;
  return [(r) => e[0]({
    lengthComputable: n,
    total: t,
    loaded: r
  }), e[1]];
}, We = (t) => (...e) => d.asap(() => t(...e)), er = A.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = A.navigator && /(msie|trident)/i.test(A.navigator.userAgent), e = document.createElement("a");
    let n;
    function r(o) {
      let a = o;
      return t && (e.setAttribute("href", a), a = e.href), e.setAttribute("href", a), {
        href: e.href,
        protocol: e.protocol ? e.protocol.replace(/:$/, "") : "",
        host: e.host,
        search: e.search ? e.search.replace(/^\?/, "") : "",
        hash: e.hash ? e.hash.replace(/^#/, "") : "",
        hostname: e.hostname,
        port: e.port,
        pathname: e.pathname.charAt(0) === "/" ? e.pathname : "/" + e.pathname
      };
    }
    return n = r(window.location.href), function(o) {
      const a = d.isString(o) ? r(o) : o;
      return a.protocol === n.protocol && a.host === n.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), tr = A.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, n, r, o, a) {
      const s = [t + "=" + encodeURIComponent(e)];
      d.isNumber(n) && s.push("expires=" + new Date(n).toGMTString()), d.isString(r) && s.push("path=" + r), d.isString(o) && s.push("domain=" + o), a === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(t) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function nr(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function rr(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function jt(t, e) {
  return t && !nr(e) ? rr(t, e) : e;
}
const Ze = (t) => t instanceof E ? { ...t } : t;
function B(t, e) {
  e = e || {};
  const n = {};
  function r(c, u, p) {
    return d.isPlainObject(c) && d.isPlainObject(u) ? d.merge.call({ caseless: p }, c, u) : d.isPlainObject(u) ? d.merge({}, u) : d.isArray(u) ? u.slice() : u;
  }
  function o(c, u, p) {
    if (d.isUndefined(u)) {
      if (!d.isUndefined(c))
        return r(void 0, c, p);
    } else return r(c, u, p);
  }
  function a(c, u) {
    if (!d.isUndefined(u))
      return r(void 0, u);
  }
  function s(c, u) {
    if (d.isUndefined(u)) {
      if (!d.isUndefined(c))
        return r(void 0, c);
    } else return r(void 0, u);
  }
  function i(c, u, p) {
    if (p in e)
      return r(c, u);
    if (p in t)
      return r(void 0, c);
  }
  const l = {
    url: a,
    method: a,
    data: a,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: i,
    headers: (c, u) => o(Ze(c), Ze(u), !0)
  };
  return d.forEach(Object.keys(Object.assign({}, t, e)), function(c) {
    const u = l[c] || o, p = u(t[c], e[c], c);
    d.isUndefined(p) && u !== i || (n[c] = p);
  }), n;
}
const Pt = (t) => {
  const e = B({}, t);
  let { data: n, withXSRFToken: r, xsrfHeaderName: o, xsrfCookieName: a, headers: s, auth: i } = e;
  e.headers = s = E.from(s), e.url = kt(jt(e.baseURL, e.url), t.params, t.paramsSerializer), i && s.set(
    "Authorization",
    "Basic " + btoa((i.username || "") + ":" + (i.password ? unescape(encodeURIComponent(i.password)) : ""))
  );
  let l;
  if (d.isFormData(n)) {
    if (A.hasStandardBrowserEnv || A.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if ((l = s.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((p) => p.trim()).filter(Boolean) : [];
      s.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (A.hasStandardBrowserEnv && (r && d.isFunction(r) && (r = r(e)), r || r !== !1 && er(e.url))) {
    const c = o && a && tr.read(a);
    c && s.set(o, c);
  }
  return e;
}, or = typeof XMLHttpRequest < "u", ar = or && function(t) {
  return new Promise(function(e, n) {
    const r = Pt(t);
    let o = r.data;
    const a = E.from(r.headers).normalize();
    let { responseType: s, onUploadProgress: i, onDownloadProgress: l } = r, c, u, p, f, h;
    function m() {
      f && f(), h && h(), r.cancelToken && r.cancelToken.unsubscribe(c), r.signal && r.signal.removeEventListener("abort", c);
    }
    let g = new XMLHttpRequest();
    g.open(r.method.toUpperCase(), r.url, !0), g.timeout = r.timeout;
    function _() {
      if (!g)
        return;
      const y = E.from(
        "getAllResponseHeaders" in g && g.getAllResponseHeaders()
      ), S = {
        data: !s || s === "text" || s === "json" ? g.responseText : g.response,
        status: g.status,
        statusText: g.statusText,
        headers: y,
        config: t,
        request: g
      };
      $t(function(v) {
        e(v), m();
      }, function(v) {
        n(v), m();
      }, S), g = null;
    }
    "onloadend" in g ? g.onloadend = _ : g.onreadystatechange = function() {
      !g || g.readyState !== 4 || g.status === 0 && !(g.responseURL && g.responseURL.indexOf("file:") === 0) || setTimeout(_);
    }, g.onabort = function() {
      g && (n(new b("Request aborted", b.ECONNABORTED, t, g)), g = null);
    }, g.onerror = function() {
      n(new b("Network Error", b.ERR_NETWORK, t, g)), g = null;
    }, g.ontimeout = function() {
      let y = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const S = r.transitional || Ot;
      r.timeoutErrorMessage && (y = r.timeoutErrorMessage), n(new b(
        y,
        S.clarifyTimeoutError ? b.ETIMEDOUT : b.ECONNABORTED,
        t,
        g
      )), g = null;
    }, o === void 0 && a.setContentType(null), "setRequestHeader" in g && d.forEach(a.toJSON(), function(y, S) {
      g.setRequestHeader(S, y);
    }), d.isUndefined(r.withCredentials) || (g.withCredentials = !!r.withCredentials), s && s !== "json" && (g.responseType = r.responseType), l && ([p, h] = ie(l, !0), g.addEventListener("progress", p)), i && g.upload && ([u, f] = ie(i), g.upload.addEventListener("progress", u), g.upload.addEventListener("loadend", f)), (r.cancelToken || r.signal) && (c = (y) => {
      g && (n(!y || y.type ? new K(null, t, g) : y), g.abort(), g = null);
    }, r.cancelToken && r.cancelToken.subscribe(c), r.signal && (r.signal.aborted ? c() : r.signal.addEventListener("abort", c)));
    const w = Yn(r.url);
    if (w && A.protocols.indexOf(w) === -1) {
      n(new b("Unsupported protocol " + w + ":", b.ERR_BAD_REQUEST, t));
      return;
    }
    g.send(o || null);
  });
}, sr = (t, e) => {
  let n = new AbortController(), r;
  const o = function(l) {
    if (!r) {
      r = !0, s();
      const c = l instanceof Error ? l : this.reason;
      n.abort(c instanceof b ? c : new K(c instanceof Error ? c.message : c));
    }
  };
  let a = e && setTimeout(() => {
    o(new b(`timeout ${e} of ms exceeded`, b.ETIMEDOUT));
  }, e);
  const s = () => {
    t && (a && clearTimeout(a), a = null, t.forEach((l) => {
      l && (l.removeEventListener ? l.removeEventListener("abort", o) : l.unsubscribe(o));
    }), t = null);
  };
  t.forEach((l) => l && l.addEventListener && l.addEventListener("abort", o));
  const { signal: i } = n;
  return i.unsubscribe = s, [i, () => {
    a && clearTimeout(a), a = null;
  }];
}, ir = function* (t, e) {
  let n = t.byteLength;
  if (n < e) {
    yield t;
    return;
  }
  let r = 0, o;
  for (; r < n; )
    o = r + e, yield t.slice(r, o), r = o;
}, lr = async function* (t, e, n) {
  for await (const r of t)
    yield* ir(ArrayBuffer.isView(r) ? r : await n(String(r)), e);
}, Ye = (t, e, n, r, o) => {
  const a = lr(t, e, o);
  let s = 0, i, l = (c) => {
    i || (i = !0, r && r(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: u, value: p } = await a.next();
        if (u) {
          l(), c.close();
          return;
        }
        let f = p.byteLength;
        if (n) {
          let h = s += f;
          n(h);
        }
        c.enqueue(new Uint8Array(p));
      } catch (u) {
        throw l(u), u;
      }
    },
    cancel(c) {
      return l(c), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, _e = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", At = _e && typeof ReadableStream == "function", $e = _e && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((t) => (e) => t.encode(e))(new TextEncoder()) : async (t) => new Uint8Array(await new Response(t).arrayBuffer())), Lt = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, cr = At && Lt(() => {
  let t = !1;
  const e = new Request(A.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return t = !0, "half";
    }
  }).headers.has("Content-Type");
  return t && !e;
}), Qe = 64 * 1024, je = At && Lt(() => d.isReadableStream(new Response("").body)), le = {
  stream: je && ((t) => t.body)
};
_e && ((t) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !le[e] && (le[e] = d.isFunction(t[e]) ? (n) => n[e]() : (n, r) => {
      throw new b(`Response type '${e}' is not supported`, b.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const ur = async (t) => {
  if (t == null)
    return 0;
  if (d.isBlob(t))
    return t.size;
  if (d.isSpecCompliantForm(t))
    return (await new Request(t).arrayBuffer()).byteLength;
  if (d.isArrayBufferView(t) || d.isArrayBuffer(t))
    return t.byteLength;
  if (d.isURLSearchParams(t) && (t = t + ""), d.isString(t))
    return (await $e(t)).byteLength;
}, fr = async (t, e) => d.toFiniteNumber(t.getContentLength()) ?? ur(e), dr = _e && (async (t) => {
  let {
    url: e,
    method: n,
    data: r,
    signal: o,
    cancelToken: a,
    timeout: s,
    onDownloadProgress: i,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: p = "same-origin",
    fetchOptions: f
  } = Pt(t);
  c = c ? (c + "").toLowerCase() : "text";
  let [h, m] = o || a || s ? sr([o, a], s) : [], g, _;
  const w = () => {
    !g && setTimeout(() => {
      h && h.unsubscribe();
    }), g = !0;
  };
  let y;
  try {
    if (l && cr && n !== "get" && n !== "head" && (y = await fr(u, r)) !== 0) {
      let x = new Request(e, {
        method: "POST",
        body: r,
        duplex: "half"
      }), L;
      if (d.isFormData(r) && (L = x.headers.get("content-type")) && u.setContentType(L), x.body) {
        const [q, F] = Ge(
          y,
          ie(We(l))
        );
        r = Ye(x.body, Qe, q, F, $e);
      }
    }
    d.isString(p) || (p = p ? "include" : "omit");
    const S = "credentials" in Request.prototype;
    _ = new Request(e, {
      ...f,
      signal: h,
      method: n.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: S ? p : void 0
    });
    let v = await fetch(_);
    const O = je && (c === "stream" || c === "response");
    if (je && (i || O)) {
      const x = {};
      ["status", "statusText", "headers"].forEach((T) => {
        x[T] = v[T];
      });
      const L = d.toFiniteNumber(v.headers.get("content-length")), [q, F] = i && Ge(
        L,
        ie(We(i), !0)
      ) || [];
      v = new Response(
        Ye(v.body, Qe, q, () => {
          F && F(), O && w();
        }, $e),
        x
      );
    }
    c = c || "text";
    let $ = await le[d.findKey(le, c) || "text"](v, t);
    return !O && w(), m && m(), await new Promise((x, L) => {
      $t(x, L, {
        data: $,
        headers: E.from(v.headers),
        status: v.status,
        statusText: v.statusText,
        config: t,
        request: _
      });
    });
  } catch (S) {
    throw w(), S && S.name === "TypeError" && /fetch/i.test(S.message) ? Object.assign(
      new b("Network Error", b.ERR_NETWORK, t, _),
      {
        cause: S.cause || S
      }
    ) : b.from(S, S && S.code, t, _);
  }
}), Pe = {
  http: jn,
  xhr: ar,
  fetch: dr
};
d.forEach(Pe, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const Xe = (t) => `- ${t}`, pr = (t) => d.isFunction(t) || t === null || t === !1, Ct = {
  getAdapter: (t) => {
    t = d.isArray(t) ? t : [t];
    const { length: e } = t;
    let n, r;
    const o = {};
    for (let a = 0; a < e; a++) {
      n = t[a];
      let s;
      if (r = n, !pr(n) && (r = Pe[(s = String(n)).toLowerCase()], r === void 0))
        throw new b(`Unknown adapter '${s}'`);
      if (r)
        break;
      o[s || "#" + a] = r;
    }
    if (!r) {
      const a = Object.entries(o).map(
        ([i, l]) => `adapter ${i} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let s = e ? a.length > 1 ? `since :
` + a.map(Xe).join(`
`) : " " + Xe(a[0]) : "as no adapter specified";
      throw new b(
        "There is no suitable adapter to dispatch the request " + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: Pe
};
function Se(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new K(null, t);
}
function et(t) {
  return Se(t), t.headers = E.from(t.headers), t.data = xe.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), Ct.getAdapter(t.adapter || ne.adapter)(t).then(function(e) {
    return Se(t), e.data = xe.call(
      t,
      t.transformResponse,
      e
    ), e.headers = E.from(e.headers), e;
  }, function(e) {
    return Et(e) || (Se(t), e && e.response && (e.response.data = xe.call(
      t,
      t.transformResponse,
      e.response
    ), e.response.headers = E.from(e.response.headers))), Promise.reject(e);
  });
}
const Nt = "1.7.5", Fe = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  Fe[t] = function(n) {
    return typeof n === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const tt = {};
Fe.transitional = function(t, e, n) {
  function r(o, a) {
    return "[Axios v" + Nt + "] Transitional option '" + o + "'" + a + (n ? ". " + n : "");
  }
  return (o, a, s) => {
    if (t === !1)
      throw new b(
        r(a, " has been removed" + (e ? " in " + e : "")),
        b.ERR_DEPRECATED
      );
    return e && !tt[a] && (tt[a] = !0, console.warn(
      r(
        a,
        " has been deprecated since v" + e + " and will be removed in the near future"
      )
    )), t ? t(o, a, s) : !0;
  };
};
function hr(t, e, n) {
  if (typeof t != "object")
    throw new b("options must be an object", b.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(t);
  let o = r.length;
  for (; o-- > 0; ) {
    const a = r[o], s = e[a];
    if (s) {
      const i = t[a], l = i === void 0 || s(i, a, t);
      if (l !== !0)
        throw new b("option " + a + " must be " + l, b.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new b("Unknown option " + a, b.ERR_BAD_OPTION);
  }
}
const Ae = {
  assertOptions: hr,
  validators: Fe
}, D = Ae.validators;
let z = class {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new qe(),
      response: new qe()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, e) {
    try {
      return await this._request(t, e);
    } catch (n) {
      if (n instanceof Error) {
        let r;
        Error.captureStackTrace ? Error.captureStackTrace(r = {}) : r = new Error();
        const o = r.stack ? r.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? o && !String(n.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + o) : n.stack = o;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(t, e) {
    typeof t == "string" ? (e = e || {}, e.url = t) : e = t || {}, e = B(this.defaults, e);
    const { transitional: n, paramsSerializer: r, headers: o } = e;
    n !== void 0 && Ae.assertOptions(n, {
      silentJSONParsing: D.transitional(D.boolean),
      forcedJSONParsing: D.transitional(D.boolean),
      clarifyTimeoutError: D.transitional(D.boolean)
    }, !1), r != null && (d.isFunction(r) ? e.paramsSerializer = {
      serialize: r
    } : Ae.assertOptions(r, {
      encode: D.function,
      serialize: D.function
    }, !0)), e.method = (e.method || this.defaults.method || "get").toLowerCase();
    let a = o && d.merge(
      o.common,
      o[e.method]
    );
    o && d.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (h) => {
        delete o[h];
      }
    ), e.headers = E.concat(a, o);
    const s = [];
    let i = !0;
    this.interceptors.request.forEach(function(h) {
      typeof h.runWhen == "function" && h.runWhen(e) === !1 || (i = i && h.synchronous, s.unshift(h.fulfilled, h.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(h) {
      l.push(h.fulfilled, h.rejected);
    });
    let c, u = 0, p;
    if (!i) {
      const h = [et.bind(this), void 0];
      for (h.unshift.apply(h, s), h.push.apply(h, l), p = h.length, c = Promise.resolve(e); u < p; )
        c = c.then(h[u++], h[u++]);
      return c;
    }
    p = s.length;
    let f = e;
    for (u = 0; u < p; ) {
      const h = s[u++], m = s[u++];
      try {
        f = h(f);
      } catch (g) {
        m.call(this, g);
        break;
      }
    }
    try {
      c = et.call(this, f);
    } catch (h) {
      return Promise.reject(h);
    }
    for (u = 0, p = l.length; u < p; )
      c = c.then(l[u++], l[u++]);
    return c;
  }
  getUri(t) {
    t = B(this.defaults, t);
    const e = jt(t.baseURL, t.url);
    return kt(e, t.params, t.paramsSerializer);
  }
};
d.forEach(["delete", "get", "head", "options"], function(t) {
  z.prototype[t] = function(e, n) {
    return this.request(B(n || {}, {
      method: t,
      url: e,
      data: (n || {}).data
    }));
  };
});
d.forEach(["post", "put", "patch"], function(t) {
  function e(n) {
    return function(r, o, a) {
      return this.request(B(a || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: r,
        data: o
      }));
    };
  }
  z.prototype[t] = e(), z.prototype[t + "Form"] = e(!0);
});
let gr = class Tt {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(o) {
      n = o;
    });
    const r = this;
    this.promise.then((o) => {
      if (!r._listeners) return;
      let a = r._listeners.length;
      for (; a-- > 0; )
        r._listeners[a](o);
      r._listeners = null;
    }), this.promise.then = (o) => {
      let a;
      const s = new Promise((i) => {
        r.subscribe(i), a = i;
      }).then(o);
      return s.cancel = function() {
        r.unsubscribe(a);
      }, s;
    }, e(function(o, a, s) {
      r.reason || (r.reason = new K(o, a, s), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(e);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new Tt(function(n) {
        e = n;
      }),
      cancel: e
    };
  }
};
function mr(t) {
  return function(e) {
    return t.apply(null, e);
  };
}
function _r(t) {
  return d.isObject(t) && t.isAxiosError === !0;
}
const Le = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Le).forEach(([t, e]) => {
  Le[e] = t;
});
function Dt(t) {
  const e = new z(t), n = dt(z.prototype.request, e);
  return d.extend(n, z.prototype, e, { allOwnKeys: !0 }), d.extend(n, e, null, { allOwnKeys: !0 }), n.create = function(r) {
    return Dt(B(t, r));
  }, n;
}
const k = Dt(ne);
k.Axios = z;
k.CanceledError = K;
k.CancelToken = gr;
k.isCancel = Et;
k.VERSION = Nt;
k.toFormData = me;
k.AxiosError = b;
k.Cancel = k.CanceledError;
k.all = function(t) {
  return Promise.all(t);
};
k.spread = mr;
k.isAxiosError = _r;
k.mergeConfig = B;
k.AxiosHeaders = E;
k.formToJSON = (t) => Rt(d.isHTMLForm(t) ? new FormData(t) : t);
k.getAdapter = Ct.getAdapter;
k.HttpStatusCode = Le;
k.default = k;
const {
  Axios: mi,
  AxiosError: br,
  CanceledError: _i,
  isCancel: bi,
  CancelToken: yi,
  VERSION: vi,
  all: wi,
  Cancel: xi,
  isAxiosError: Si,
  spread: ki,
  toFormData: Oi,
  AxiosHeaders: Ri,
  HttpStatusCode: Ei,
  formToJSON: $i,
  getAdapter: ji,
  mergeConfig: Pi
} = k, yr = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_,+.~#?&/=]*)$/;
class vr {
  constructor(e) {
    ft(this, "baseUrl"), this.baseUrl = e;
  }
  async fetch(e, n = "GET", r = {}) {
    if (!this.baseUrl)
      throw new Error("No base URL set");
    const o = yr.test(e) ? e : `${this.baseUrl}${e}`;
    o.includes(this.baseUrl) && (r.withCredentials = !0);
    try {
      return (await k(o, {
        ...r,
        method: n,
        data: r.data,
        headers: r.headers,
        withCredentials: r.withCredentials
      })).data;
    } catch (a) {
      throw a instanceof br ? new Be(`${a.code} - ${a.status} - ${o}`, a.status) : new Be("An error occured while fetching");
    }
  }
  getBaseUrl() {
    return this.baseUrl;
  }
  setBaseUrl(e) {
    this.baseUrl = e;
  }
  async get(e, n = {}) {
    return this.fetch(e, "GET", n);
  }
  async post(e, n = {}) {
    return this.fetch(e, "POST", {
      ...n,
      headers: {
        "Content-Type": "application/json",
        ...n.headers
      }
    });
  }
  async put(e, n = {}) {
    return this.fetch(e, "PUT", n);
  }
  async delete(e, n = {}) {
    return this.fetch(e, "DELETE", n);
  }
  async patch(e, n = {}) {
    return this.fetch(e, "PATCH", n);
  }
}
let be;
function Ai(t) {
  be = new vr(t);
}
const wr = {
  type: "logger",
  log(t) {
    this.output("log", t);
  },
  warn(t) {
    this.output("warn", t);
  },
  error(t) {
    this.output("error", t);
  },
  output(t, e) {
    console && console[t] && console[t].apply(console, e);
  }
};
class ce {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(e, n);
  }
  init(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = n.prefix || "i18next:", this.logger = e || wr, this.options = n, this.debug = n.debug;
  }
  log() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return this.forward(n, "log", "", !0);
  }
  warn() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "", !0);
  }
  error() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return this.forward(n, "error", "");
  }
  deprecate() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, n, r, o) {
    return o && !this.debug ? null : (typeof e[0] == "string" && (e[0] = `${r}${this.prefix} ${e[0]}`), this.logger[n](e));
  }
  create(e) {
    return new ce(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new ce(this.logger, e);
  }
}
var N = new ce();
class ye {
  constructor() {
    this.observers = {};
  }
  on(e, n) {
    return e.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const o = this.observers[r].get(n) || 0;
      this.observers[r].set(n, o + 1);
    }), this;
  }
  off(e, n) {
    if (this.observers[e]) {
      if (!n) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(n);
    }
  }
  emit(e) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      r[o - 1] = arguments[o];
    this.observers[e] && Array.from(this.observers[e].entries()).forEach((s) => {
      let [i, l] = s;
      for (let c = 0; c < l; c++)
        i(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((s) => {
      let [i, l] = s;
      for (let c = 0; c < l; c++)
        i.apply(i, [e, ...r]);
    });
  }
}
function Y() {
  let t, e;
  const n = new Promise((r, o) => {
    t = r, e = o;
  });
  return n.resolve = t, n.reject = e, n;
}
function nt(t) {
  return t == null ? "" : "" + t;
}
function xr(t, e, n) {
  t.forEach((r) => {
    e[r] && (n[r] = e[r]);
  });
}
const Sr = /###/g;
function Q(t, e, n) {
  function r(i) {
    return i && i.indexOf("###") > -1 ? i.replace(Sr, ".") : i;
  }
  function o() {
    return !t || typeof t == "string";
  }
  const a = typeof e != "string" ? e : e.split(".");
  let s = 0;
  for (; s < a.length - 1; ) {
    if (o()) return {};
    const i = r(a[s]);
    !t[i] && n && (t[i] = new n()), Object.prototype.hasOwnProperty.call(t, i) ? t = t[i] : t = {}, ++s;
  }
  return o() ? {} : {
    obj: t,
    k: r(a[s])
  };
}
function rt(t, e, n) {
  const {
    obj: r,
    k: o
  } = Q(t, e, Object);
  if (r !== void 0 || e.length === 1) {
    r[o] = n;
    return;
  }
  let a = e[e.length - 1], s = e.slice(0, e.length - 1), i = Q(t, s, Object);
  for (; i.obj === void 0 && s.length; )
    a = `${s[s.length - 1]}.${a}`, s = s.slice(0, s.length - 1), i = Q(t, s, Object), i && i.obj && typeof i.obj[`${i.k}.${a}`] < "u" && (i.obj = void 0);
  i.obj[`${i.k}.${a}`] = n;
}
function kr(t, e, n, r) {
  const {
    obj: o,
    k: a
  } = Q(t, e, Object);
  o[a] = o[a] || [], o[a].push(n);
}
function ue(t, e) {
  const {
    obj: n,
    k: r
  } = Q(t, e);
  if (n)
    return n[r];
}
function Or(t, e, n) {
  const r = ue(t, n);
  return r !== void 0 ? r : ue(e, n);
}
function Ft(t, e, n) {
  for (const r in e)
    r !== "__proto__" && r !== "constructor" && (r in t ? typeof t[r] == "string" || t[r] instanceof String || typeof e[r] == "string" || e[r] instanceof String ? n && (t[r] = e[r]) : Ft(t[r], e[r], n) : t[r] = e[r]);
  return t;
}
function V(t) {
  return t.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var Rr = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function Er(t) {
  return typeof t == "string" ? t.replace(/[&<>"'\/]/g, (e) => Rr[e]) : t;
}
class $r {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const n = this.regExpMap.get(e);
    if (n !== void 0)
      return n;
    const r = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, r), this.regExpQueue.push(e), r;
  }
}
const jr = [" ", ",", "?", "!", ";"], Pr = new $r(20);
function Ar(t, e, n) {
  e = e || "", n = n || "";
  const r = jr.filter((s) => e.indexOf(s) < 0 && n.indexOf(s) < 0);
  if (r.length === 0) return !0;
  const o = Pr.getRegExp(`(${r.map((s) => s === "?" ? "\\?" : s).join("|")})`);
  let a = !o.test(t);
  if (!a) {
    const s = t.indexOf(n);
    s > 0 && !o.test(t.substring(0, s)) && (a = !0);
  }
  return a;
}
function Ce(t, e) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!t) return;
  if (t[e]) return t[e];
  const r = e.split(n);
  let o = t;
  for (let a = 0; a < r.length; ) {
    if (!o || typeof o != "object")
      return;
    let s, i = "";
    for (let l = a; l < r.length; ++l)
      if (l !== a && (i += n), i += r[l], s = o[i], s !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof s) > -1 && l < r.length - 1)
          continue;
        a += l - a + 1;
        break;
      }
    o = s;
  }
  return o;
}
function fe(t) {
  return t && t.indexOf("_") > 0 ? t.replace("_", "-") : t;
}
class ot extends ye {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = e || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const n = this.options.ns.indexOf(e);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(e, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const a = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator, s = o.ignoreJSONStructure !== void 0 ? o.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let i;
    e.indexOf(".") > -1 ? i = e.split(".") : (i = [e, n], r && (Array.isArray(r) ? i.push(...r) : typeof r == "string" && a ? i.push(...r.split(a)) : i.push(r)));
    const l = ue(this.data, i);
    return !l && !n && !r && e.indexOf(".") > -1 && (e = i[0], n = i[1], r = i.slice(2).join(".")), l || !s || typeof r != "string" ? l : Ce(this.data && this.data[e] && this.data[e][n], r, a);
  }
  addResource(e, n, r, o) {
    let a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const s = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator;
    let i = [e, n];
    r && (i = i.concat(s ? r.split(s) : r)), e.indexOf(".") > -1 && (i = e.split("."), o = n, n = i[1]), this.addNamespaces(n), rt(this.data, i, o), a.silent || this.emit("added", e, n, r, o);
  }
  addResources(e, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const a in r)
      (typeof r[a] == "string" || Array.isArray(r[a])) && this.addResource(e, n, a, r[a], {
        silent: !0
      });
    o.silent || this.emit("added", e, n, r);
  }
  addResourceBundle(e, n, r, o, a) {
    let s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, i = [e, n];
    e.indexOf(".") > -1 && (i = e.split("."), o = r, r = n, n = i[1]), this.addNamespaces(n);
    let l = ue(this.data, i) || {};
    s.skipCopy || (r = JSON.parse(JSON.stringify(r))), o ? Ft(l, r, a) : l = {
      ...l,
      ...r
    }, rt(this.data, i, l), s.silent || this.emit("added", e, n, r);
  }
  removeResourceBundle(e, n) {
    this.hasResourceBundle(e, n) && delete this.data[e][n], this.removeNamespaces(n), this.emit("removed", e, n);
  }
  hasResourceBundle(e, n) {
    return this.getResource(e, n) !== void 0;
  }
  getResourceBundle(e, n) {
    return n || (n = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(e, n)
    } : this.getResource(e, n);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const n = this.getDataByLanguage(e);
    return !!(n && Object.keys(n) || []).find((o) => n[o] && Object.keys(n[o]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var It = {
  processors: {},
  addPostProcessor(t) {
    this.processors[t.name] = t;
  },
  handle(t, e, n, r, o) {
    return t.forEach((a) => {
      this.processors[a] && (e = this.processors[a].process(e, n, r, o));
    }), e;
  }
};
const at = {};
class de extends ye {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), xr(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = N.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (e == null)
      return !1;
    const r = this.resolve(e, n);
    return r && r.res !== void 0;
  }
  extractFromKey(e, n) {
    let r = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const o = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let a = n.ns || this.options.defaultNS || [];
    const s = r && e.indexOf(r) > -1, i = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !Ar(e, r, o);
    if (s && !i) {
      const l = e.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: e,
          namespaces: a
        };
      const c = e.split(r);
      (r !== o || r === o && this.options.ns.indexOf(c[0]) > -1) && (a = c.shift()), e = c.join(o);
    }
    return typeof a == "string" && (a = [a]), {
      key: e,
      namespaces: a
    };
  }
  translate(e, n, r) {
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), e == null) return "";
    Array.isArray(e) || (e = [String(e)]);
    const o = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, a = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: s,
      namespaces: i
    } = this.extractFromKey(e[e.length - 1], n), l = i[i.length - 1], c = n.lng || this.language, u = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (c && c.toLowerCase() === "cimode") {
      if (u) {
        const v = n.nsSeparator || this.options.nsSeparator;
        return o ? {
          res: `${l}${v}${s}`,
          usedKey: s,
          exactUsedKey: s,
          usedLng: c,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(n)
        } : `${l}${v}${s}`;
      }
      return o ? {
        res: s,
        usedKey: s,
        exactUsedKey: s,
        usedLng: c,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(n)
      } : s;
    }
    const p = this.resolve(e, n);
    let f = p && p.res;
    const h = p && p.usedKey || s, m = p && p.exactUsedKey || s, g = Object.prototype.toString.apply(f), _ = ["[object Number]", "[object Function]", "[object RegExp]"], w = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, y = !this.i18nFormat || this.i18nFormat.handleAsObject;
    if (y && f && (typeof f != "string" && typeof f != "boolean" && typeof f != "number") && _.indexOf(g) < 0 && !(typeof w == "string" && Array.isArray(f))) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const v = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(h, f, {
          ...n,
          ns: i
        }) : `key '${s} (${this.language})' returned an object instead of string.`;
        return o ? (p.res = v, p.usedParams = this.getUsedParamsDetails(n), p) : v;
      }
      if (a) {
        const v = Array.isArray(f), O = v ? [] : {}, $ = v ? m : h;
        for (const x in f)
          if (Object.prototype.hasOwnProperty.call(f, x)) {
            const L = `${$}${a}${x}`;
            O[x] = this.translate(L, {
              ...n,
              joinArrays: !1,
              ns: i
            }), O[x] === L && (O[x] = f[x]);
          }
        f = O;
      }
    } else if (y && typeof w == "string" && Array.isArray(f))
      f = f.join(w), f && (f = this.extendTranslation(f, e, n, r));
    else {
      let v = !1, O = !1;
      const $ = n.count !== void 0 && typeof n.count != "string", x = de.hasDefaultValue(n), L = $ ? this.pluralResolver.getSuffix(c, n.count, n) : "", q = n.ordinal && $ ? this.pluralResolver.getSuffix(c, n.count, {
        ordinal: !1
      }) : "", F = $ && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), T = F && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${L}`] || n[`defaultValue${q}`] || n.defaultValue;
      !this.isValidLookup(f) && x && (v = !0, f = T), this.isValidLookup(f) || (O = !0, f = s);
      const zt = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && O ? void 0 : f, J = x && T !== f && this.options.updateMissing;
      if (O || v || J) {
        if (this.logger.log(J ? "updateKey" : "missingKey", c, l, s, J ? T : f), a) {
          const j = this.resolve(s, {
            ...n,
            keySeparator: !1
          });
          j && j.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let G = [];
        const re = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && re && re[0])
          for (let j = 0; j < re.length; j++)
            G.push(re[j]);
        else this.options.saveMissingTo === "all" ? G = this.languageUtils.toResolveHierarchy(n.lng || this.language) : G.push(n.lng || this.language);
        const Ue = (j, I, W) => {
          const ze = x && W !== f ? W : zt;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(j, l, I, ze, J, n) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(j, l, I, ze, J, n), this.emit("missingKey", j, l, I, f);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && $ ? G.forEach((j) => {
          const I = this.pluralResolver.getSuffixes(j, n);
          F && n[`defaultValue${this.options.pluralSeparator}zero`] && I.indexOf(`${this.options.pluralSeparator}zero`) < 0 && I.push(`${this.options.pluralSeparator}zero`), I.forEach((W) => {
            Ue([j], s + W, n[`defaultValue${W}`] || T);
          });
        }) : Ue(G, s, T));
      }
      f = this.extendTranslation(f, e, n, p, r), O && f === s && this.options.appendNamespaceToMissingKey && (f = `${l}:${s}`), (O || v) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? f = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${s}` : s, v ? f : void 0) : f = this.options.parseMissingKeyHandler(f));
    }
    return o ? (p.res = f, p.usedParams = this.getUsedParamsDetails(n), p) : f;
  }
  extendTranslation(e, n, r, o, a) {
    var s = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...r
      }, r.lng || this.language || o.usedLng, o.usedNS, o.usedKey, {
        resolved: o
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init({
        ...r,
        interpolation: {
          ...this.options.interpolation,
          ...r.interpolation
        }
      });
      const c = typeof e == "string" && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (c) {
        const f = e.match(this.interpolator.nestingRegexp);
        u = f && f.length;
      }
      let p = r.replace && typeof r.replace != "string" ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (p = {
        ...this.options.interpolation.defaultVariables,
        ...p
      }), e = this.interpolator.interpolate(e, p, r.lng || this.language, r), c) {
        const f = e.match(this.interpolator.nestingRegexp), h = f && f.length;
        u < h && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && o && o.res && (r.lng = o.usedLng), r.nest !== !1 && (e = this.interpolator.nest(e, function() {
        for (var f = arguments.length, h = new Array(f), m = 0; m < f; m++)
          h[m] = arguments[m];
        return a && a[0] === h[0] && !r.context ? (s.logger.warn(`It seems you are nesting recursively key: ${h[0]} in key: ${n[0]}`), null) : s.translate(...h, n);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const i = r.postProcess || this.options.postProcess, l = typeof i == "string" ? [i] : i;
    return e != null && l && l.length && r.applyPostProcessor !== !1 && (e = It.handle(l, e, n, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...o,
        usedParams: this.getUsedParamsDetails(r)
      },
      ...r
    } : r, this)), e;
  }
  resolve(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, o, a, s, i;
    return typeof e == "string" && (e = [e]), e.forEach((l) => {
      if (this.isValidLookup(r)) return;
      const c = this.extractFromKey(l, n), u = c.key;
      o = u;
      let p = c.namespaces;
      this.options.fallbackNS && (p = p.concat(this.options.fallbackNS));
      const f = n.count !== void 0 && typeof n.count != "string", h = f && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), m = n.context !== void 0 && (typeof n.context == "string" || typeof n.context == "number") && n.context !== "", g = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      p.forEach((_) => {
        this.isValidLookup(r) || (i = _, !at[`${g[0]}-${_}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(i) && (at[`${g[0]}-${_}`] = !0, this.logger.warn(`key "${o}" for languages "${g.join(", ")}" won't get resolved as namespace "${i}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), g.forEach((w) => {
          if (this.isValidLookup(r)) return;
          s = w;
          const y = [u];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(y, u, w, _, n);
          else {
            let v;
            f && (v = this.pluralResolver.getSuffix(w, n.count, n));
            const O = `${this.options.pluralSeparator}zero`, $ = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (f && (y.push(u + v), n.ordinal && v.indexOf($) === 0 && y.push(u + v.replace($, this.options.pluralSeparator)), h && y.push(u + O)), m) {
              const x = `${u}${this.options.contextSeparator}${n.context}`;
              y.push(x), f && (y.push(x + v), n.ordinal && v.indexOf($) === 0 && y.push(x + v.replace($, this.options.pluralSeparator)), h && y.push(x + O));
            }
          }
          let S;
          for (; S = y.pop(); )
            this.isValidLookup(r) || (a = S, r = this.getResource(w, _, S, n));
        }));
      });
    }), {
      res: r,
      usedKey: o,
      exactUsedKey: a,
      usedLng: s,
      usedNS: i
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, n, r, o) : this.resourceStore.getResource(e, n, r, o);
  }
  getUsedParamsDetails() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = e.replace && typeof e.replace != "string";
    let o = r ? e.replace : e;
    if (r && typeof e.count < "u" && (o.count = e.count), this.options.interpolation.defaultVariables && (o = {
      ...this.options.interpolation.defaultVariables,
      ...o
    }), !r) {
      o = {
        ...o
      };
      for (const a of n)
        delete o[a];
    }
    return o;
  }
  static hasDefaultValue(e) {
    const n = "defaultValue";
    for (const r in e)
      if (Object.prototype.hasOwnProperty.call(e, r) && n === r.substring(0, n.length) && e[r] !== void 0)
        return !0;
    return !1;
  }
}
function ke(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
class st {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = N.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = fe(e), !e || e.indexOf("-") < 0) return null;
    const n = e.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = fe(e), !e || e.indexOf("-") < 0) return e;
    const n = e.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(e) {
    if (typeof e == "string" && e.indexOf("-") > -1) {
      const n = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = e.split("-");
      return this.options.lowerCaseLng ? r = r.map((o) => o.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = ke(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = ke(r[1].toLowerCase())), n.indexOf(r[2].toLowerCase()) > -1 && (r[2] = ke(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e) return null;
    let n;
    return e.forEach((r) => {
      if (n) return;
      const o = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(o)) && (n = o);
    }), !n && this.options.supportedLngs && e.forEach((r) => {
      if (n) return;
      const o = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(o)) return n = o;
      n = this.options.supportedLngs.find((a) => {
        if (a === o) return a;
        if (!(a.indexOf("-") < 0 && o.indexOf("-") < 0) && (a.indexOf("-") > 0 && o.indexOf("-") < 0 && a.substring(0, a.indexOf("-")) === o || a.indexOf(o) === 0 && o.length > 1))
          return a;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(e, n) {
    if (!e) return [];
    if (typeof e == "function" && (e = e(n)), typeof e == "string" && (e = [e]), Array.isArray(e)) return e;
    if (!n) return e.default || [];
    let r = e[n];
    return r || (r = e[this.getScriptPartFromCode(n)]), r || (r = e[this.formatLanguageCode(n)]), r || (r = e[this.getLanguagePartFromCode(n)]), r || (r = e.default), r || [];
  }
  toResolveHierarchy(e, n) {
    const r = this.getFallbackCodes(n || this.options.fallbackLng || [], e), o = [], a = (s) => {
      s && (this.isSupportedCode(s) ? o.push(s) : this.logger.warn(`rejecting language code not found in supportedLngs: ${s}`));
    };
    return typeof e == "string" && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && a(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && a(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && a(this.getLanguagePartFromCode(e))) : typeof e == "string" && a(this.formatLanguageCode(e)), r.forEach((s) => {
      o.indexOf(s) < 0 && a(this.formatLanguageCode(s));
    }), o;
  }
}
let Lr = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], Cr = {
  1: function(t) {
    return +(t > 1);
  },
  2: function(t) {
    return +(t != 1);
  },
  3: function(t) {
    return 0;
  },
  4: function(t) {
    return t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2;
  },
  5: function(t) {
    return t == 0 ? 0 : t == 1 ? 1 : t == 2 ? 2 : t % 100 >= 3 && t % 100 <= 10 ? 3 : t % 100 >= 11 ? 4 : 5;
  },
  6: function(t) {
    return t == 1 ? 0 : t >= 2 && t <= 4 ? 1 : 2;
  },
  7: function(t) {
    return t == 1 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2;
  },
  8: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : t != 8 && t != 11 ? 2 : 3;
  },
  9: function(t) {
    return +(t >= 2);
  },
  10: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : t < 7 ? 2 : t < 11 ? 3 : 4;
  },
  11: function(t) {
    return t == 1 || t == 11 ? 0 : t == 2 || t == 12 ? 1 : t > 2 && t < 20 ? 2 : 3;
  },
  12: function(t) {
    return +(t % 10 != 1 || t % 100 == 11);
  },
  13: function(t) {
    return +(t !== 0);
  },
  14: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : t == 3 ? 2 : 3;
  },
  15: function(t) {
    return t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2;
  },
  16: function(t) {
    return t % 10 == 1 && t % 100 != 11 ? 0 : t !== 0 ? 1 : 2;
  },
  17: function(t) {
    return t == 1 || t % 10 == 1 && t % 100 != 11 ? 0 : 1;
  },
  18: function(t) {
    return t == 0 ? 0 : t == 1 ? 1 : 2;
  },
  19: function(t) {
    return t == 1 ? 0 : t == 0 || t % 100 > 1 && t % 100 < 11 ? 1 : t % 100 > 10 && t % 100 < 20 ? 2 : 3;
  },
  20: function(t) {
    return t == 1 ? 0 : t == 0 || t % 100 > 0 && t % 100 < 20 ? 1 : 2;
  },
  21: function(t) {
    return t % 100 == 1 ? 1 : t % 100 == 2 ? 2 : t % 100 == 3 || t % 100 == 4 ? 3 : 0;
  },
  22: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : (t < 0 || t > 10) && t % 10 == 0 ? 2 : 3;
  }
};
const Nr = ["v1", "v2", "v3"], Tr = ["v4"], it = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function Dr() {
  const t = {};
  return Lr.forEach((e) => {
    e.lngs.forEach((n) => {
      t[n] = {
        numbers: e.nr,
        plurals: Cr[e.fc]
      };
    });
  }), t;
}
class Fr {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = e, this.options = n, this.logger = N.create("pluralResolver"), (!this.options.compatibilityJSON || Tr.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Dr();
  }
  addRule(e, n) {
    this.rules[e] = n;
  }
  getRule(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        return new Intl.PluralRules(fe(e === "dev" ? "en" : e), {
          type: n.ordinal ? "ordinal" : "cardinal"
        });
      } catch {
        return;
      }
    return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
  }
  needsPlural(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(e, n);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(e, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(e, r).map((o) => `${n}${o}`);
  }
  getSuffixes(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(e, n);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((o, a) => it[o] - it[a]).map((o) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${o}`) : r.numbers.map((o) => this.getSuffix(e, o, n)) : [];
  }
  getSuffix(e, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const o = this.getRule(e, r);
    return o ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${o.select(n)}` : this.getSuffixRetroCompatible(o, n) : (this.logger.warn(`no plural rule found for: ${e}`), "");
  }
  getSuffixRetroCompatible(e, n) {
    const r = e.noAbs ? e.plurals(n) : e.plurals(Math.abs(n));
    let o = e.numbers[r];
    this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 && (o === 2 ? o = "plural" : o === 1 && (o = ""));
    const a = () => this.options.prepend && o.toString() ? this.options.prepend + o.toString() : o.toString();
    return this.options.compatibilityJSON === "v1" ? o === 1 ? "" : typeof o == "number" ? `_plural_${o.toString()}` : a() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 ? a() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !Nr.includes(this.options.compatibilityJSON);
  }
}
function lt(t, e, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, a = Or(t, e, n);
  return !a && o && typeof n == "string" && (a = Ce(t, n, r), a === void 0 && (a = Ce(e, n, r))), a;
}
class Ir {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = N.create("interpolator"), this.options = e, this.format = e.interpolation && e.interpolation.format || ((n) => n), this.init(e);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: n,
      escapeValue: r,
      useRawValueToEscape: o,
      prefix: a,
      prefixEscaped: s,
      suffix: i,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: p,
      nestingPrefix: f,
      nestingPrefixEscaped: h,
      nestingSuffix: m,
      nestingSuffixEscaped: g,
      nestingOptionsSeparator: _,
      maxReplaces: w,
      alwaysFormat: y
    } = e.interpolation;
    this.escape = n !== void 0 ? n : Er, this.escapeValue = r !== void 0 ? r : !0, this.useRawValueToEscape = o !== void 0 ? o : !1, this.prefix = a ? V(a) : s || "{{", this.suffix = i ? V(i) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : p || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = f ? V(f) : h || V("$t("), this.nestingSuffix = m ? V(m) : g || V(")"), this.nestingOptionsSeparator = _ || ",", this.maxReplaces = w || 1e3, this.alwaysFormat = y !== void 0 ? y : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (n, r) => n && n.source === r ? (n.lastIndex = 0, n) : new RegExp(r, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, n, r, o) {
    let a, s, i;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    function c(m) {
      return m.replace(/\$/g, "$$$$");
    }
    const u = (m) => {
      if (m.indexOf(this.formatSeparator) < 0) {
        const y = lt(n, l, m, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(y, void 0, r, {
          ...o,
          ...n,
          interpolationkey: m
        }) : y;
      }
      const g = m.split(this.formatSeparator), _ = g.shift().trim(), w = g.join(this.formatSeparator).trim();
      return this.format(lt(n, l, _, this.options.keySeparator, this.options.ignoreJSONStructure), w, r, {
        ...o,
        ...n,
        interpolationkey: _
      });
    };
    this.resetRegExp();
    const p = o && o.missingInterpolationHandler || this.options.missingInterpolationHandler, f = o && o.interpolation && o.interpolation.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (m) => c(m)
    }, {
      regex: this.regexp,
      safeValue: (m) => this.escapeValue ? c(this.escape(m)) : c(m)
    }].forEach((m) => {
      for (i = 0; a = m.regex.exec(e); ) {
        const g = a[1].trim();
        if (s = u(g), s === void 0)
          if (typeof p == "function") {
            const w = p(e, a, o);
            s = typeof w == "string" ? w : "";
          } else if (o && Object.prototype.hasOwnProperty.call(o, g))
            s = "";
          else if (f) {
            s = a[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${g} for interpolating ${e}`), s = "";
        else typeof s != "string" && !this.useRawValueToEscape && (s = nt(s));
        const _ = m.safeValue(s);
        if (e = e.replace(a[0], _), f ? (m.regex.lastIndex += s.length, m.regex.lastIndex -= a[0].length) : m.regex.lastIndex = 0, i++, i >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o, a, s;
    function i(l, c) {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const p = l.split(new RegExp(`${u}[ ]*{`));
      let f = `{${p[1]}`;
      l = p[0], f = this.interpolate(f, s);
      const h = f.match(/'/g), m = f.match(/"/g);
      (h && h.length % 2 === 0 && !m || m.length % 2 !== 0) && (f = f.replace(/'/g, '"'));
      try {
        s = JSON.parse(f), c && (s = {
          ...c,
          ...s
        });
      } catch (g) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, g), `${l}${u}${f}`;
      }
      return s.defaultValue && s.defaultValue.indexOf(this.prefix) > -1 && delete s.defaultValue, l;
    }
    for (; o = this.nestingRegexp.exec(e); ) {
      let l = [];
      s = {
        ...r
      }, s = s.replace && typeof s.replace != "string" ? s.replace : s, s.applyPostProcessor = !1, delete s.defaultValue;
      let c = !1;
      if (o[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(o[1])) {
        const u = o[1].split(this.formatSeparator).map((p) => p.trim());
        o[1] = u.shift(), l = u, c = !0;
      }
      if (a = n(i.call(this, o[1].trim(), s), s), a && o[0] === e && typeof a != "string") return a;
      typeof a != "string" && (a = nt(a)), a || (this.logger.warn(`missed to resolve ${o[1]} for nesting ${e}`), a = ""), c && (a = l.reduce((u, p) => this.format(u, p, r.lng, {
        ...r,
        interpolationkey: o[1].trim()
      }), a.trim())), e = e.replace(o[0], a), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
function Ur(t) {
  let e = t.toLowerCase().trim();
  const n = {};
  if (t.indexOf("(") > -1) {
    const r = t.split("(");
    e = r[0].toLowerCase().trim();
    const o = r[1].substring(0, r[1].length - 1);
    e === "currency" && o.indexOf(":") < 0 ? n.currency || (n.currency = o.trim()) : e === "relativetime" && o.indexOf(":") < 0 ? n.range || (n.range = o.trim()) : o.split(";").forEach((s) => {
      if (s) {
        const [i, ...l] = s.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), u = i.trim();
        n[u] || (n[u] = c), c === "false" && (n[u] = !1), c === "true" && (n[u] = !0), isNaN(c) || (n[u] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: n
  };
}
function M(t) {
  const e = {};
  return function(r, o, a) {
    const s = o + JSON.stringify(a);
    let i = e[s];
    return i || (i = t(fe(o), a), e[s] = i), i(r);
  };
}
class zr {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = N.create("formatter"), this.options = e, this.formats = {
      number: M((n, r) => {
        const o = new Intl.NumberFormat(n, {
          ...r
        });
        return (a) => o.format(a);
      }),
      currency: M((n, r) => {
        const o = new Intl.NumberFormat(n, {
          ...r,
          style: "currency"
        });
        return (a) => o.format(a);
      }),
      datetime: M((n, r) => {
        const o = new Intl.DateTimeFormat(n, {
          ...r
        });
        return (a) => o.format(a);
      }),
      relativetime: M((n, r) => {
        const o = new Intl.RelativeTimeFormat(n, {
          ...r
        });
        return (a) => o.format(a, r.range || "day");
      }),
      list: M((n, r) => {
        const o = new Intl.ListFormat(n, {
          ...r
        });
        return (a) => o.format(a);
      })
    }, this.init(e);
  }
  init(e) {
    const r = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    }).interpolation;
    this.formatSeparator = r.formatSeparator ? r.formatSeparator : r.formatSeparator || ",";
  }
  add(e, n) {
    this.formats[e.toLowerCase().trim()] = n;
  }
  addCached(e, n) {
    this.formats[e.toLowerCase().trim()] = M(n);
  }
  format(e, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return n.split(this.formatSeparator).reduce((i, l) => {
      const {
        formatName: c,
        formatOptions: u
      } = Ur(l);
      if (this.formats[c]) {
        let p = i;
        try {
          const f = o && o.formatParams && o.formatParams[o.interpolationkey] || {}, h = f.locale || f.lng || o.locale || o.lng || r;
          p = this.formats[c](i, h, {
            ...u,
            ...o,
            ...f
          });
        } catch (f) {
          this.logger.warn(f);
        }
        return p;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return i;
    }, e);
  }
}
function Br(t, e) {
  t.pending[e] !== void 0 && (delete t.pending[e], t.pendingCount--);
}
class Vr extends ye {
  constructor(e, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = e, this.store = n, this.services = r, this.languageUtils = r.languageUtils, this.options = o, this.logger = N.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = o.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = o.maxRetries >= 0 ? o.maxRetries : 5, this.retryTimeout = o.retryTimeout >= 1 ? o.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, o.backend, o);
  }
  queueLoad(e, n, r, o) {
    const a = {}, s = {}, i = {}, l = {};
    return e.forEach((c) => {
      let u = !0;
      n.forEach((p) => {
        const f = `${c}|${p}`;
        !r.reload && this.store.hasResourceBundle(c, p) ? this.state[f] = 2 : this.state[f] < 0 || (this.state[f] === 1 ? s[f] === void 0 && (s[f] = !0) : (this.state[f] = 1, u = !1, s[f] === void 0 && (s[f] = !0), a[f] === void 0 && (a[f] = !0), l[p] === void 0 && (l[p] = !0)));
      }), u || (i[c] = !0);
    }), (Object.keys(a).length || Object.keys(s).length) && this.queue.push({
      pending: s,
      pendingCount: Object.keys(s).length,
      loaded: {},
      errors: [],
      callback: o
    }), {
      toLoad: Object.keys(a),
      pending: Object.keys(s),
      toLoadLanguages: Object.keys(i),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(e, n, r) {
    const o = e.split("|"), a = o[0], s = o[1];
    n && this.emit("failedLoading", a, s, n), r && this.store.addResourceBundle(a, s, r, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = n ? -1 : 2;
    const i = {};
    this.queue.forEach((l) => {
      kr(l.loaded, [a], s), Br(l, e), n && l.errors.push(n), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        i[c] || (i[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((p) => {
          i[c][p] === void 0 && (i[c][p] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", i), this.queue = this.queue.filter((l) => !l.done);
  }
  read(e, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, s = arguments.length > 5 ? arguments[5] : void 0;
    if (!e.length) return s(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: n,
        fcName: r,
        tried: o,
        wait: a,
        callback: s
      });
      return;
    }
    this.readingCalls++;
    const i = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const p = this.waitingReads.shift();
        this.read(p.lng, p.ns, p.fcName, p.tried, p.wait, p.callback);
      }
      if (c && u && o < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, n, r, o + 1, a * 2, s);
        }, a);
        return;
      }
      s(c, u);
    }, l = this.backend[r].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(e, n);
        c && typeof c.then == "function" ? c.then((u) => i(null, u)).catch(i) : i(null, c);
      } catch (c) {
        i(c);
      }
      return;
    }
    return l(e, n, i);
  }
  prepareLoading(e, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), o && o();
    typeof e == "string" && (e = this.languageUtils.toResolveHierarchy(e)), typeof n == "string" && (n = [n]);
    const a = this.queueLoad(e, n, r, o);
    if (!a.toLoad.length)
      return a.pending.length || o(), null;
    a.toLoad.forEach((s) => {
      this.loadOne(s);
    });
  }
  load(e, n, r) {
    this.prepareLoading(e, n, {}, r);
  }
  reload(e, n, r) {
    this.prepareLoading(e, n, {
      reload: !0
    }, r);
  }
  loadOne(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = e.split("|"), o = r[0], a = r[1];
    this.read(o, a, "read", void 0, void 0, (s, i) => {
      s && this.logger.warn(`${n}loading namespace ${a} for language ${o} failed`, s), !s && i && this.logger.log(`${n}loaded namespace ${a} for language ${o}`, i), this.loaded(e, s, i);
    });
  }
  saveMissing(e, n, r, o, a) {
    let s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, i = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...s,
          isUpdate: a
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(e, n, r, o, l) : u = c(e, n, r, o), u && typeof u.then == "function" ? u.then((p) => i(null, p)).catch(i) : i(null, u);
          } catch (u) {
            i(u);
          }
        else
          c(e, n, r, o, i, l);
      }
      !e || !e[0] || this.store.addResource(e[0], n, r, o);
    }
  }
}
function ct() {
  return {
    debug: !1,
    initImmediate: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !1,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: function(e) {
      let n = {};
      if (typeof e[1] == "object" && (n = e[1]), typeof e[1] == "string" && (n.defaultValue = e[1]), typeof e[2] == "string" && (n.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
        const r = e[3] || e[2];
        Object.keys(r).forEach((o) => {
          n[o] = r[o];
        });
      }
      return n;
    },
    interpolation: {
      escapeValue: !0,
      format: (t) => t,
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !0
    }
  };
}
function ut(t) {
  return typeof t.ns == "string" && (t.ns = [t.ns]), typeof t.fallbackLng == "string" && (t.fallbackLng = [t.fallbackLng]), typeof t.fallbackNS == "string" && (t.fallbackNS = [t.fallbackNS]), t.supportedLngs && t.supportedLngs.indexOf("cimode") < 0 && (t.supportedLngs = t.supportedLngs.concat(["cimode"])), t;
}
function oe() {
}
function Mr(t) {
  Object.getOwnPropertyNames(Object.getPrototypeOf(t)).forEach((n) => {
    typeof t[n] == "function" && (t[n] = t[n].bind(t));
  });
}
class ee extends ye {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = ut(e), this.services = {}, this.logger = N, this.modules = {
      external: []
    }, Mr(this), n && !this.isInitialized && !e.isClone) {
      if (!this.options.initImmediate)
        return this.init(e, n), this;
      setTimeout(() => {
        this.init(e, n);
      }, 0);
    }
  }
  init() {
    var e = this;
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof n == "function" && (r = n, n = {}), !n.defaultNS && n.defaultNS !== !1 && n.ns && (typeof n.ns == "string" ? n.defaultNS = n.ns : n.ns.indexOf("translation") < 0 && (n.defaultNS = n.ns[0]));
    const o = ct();
    this.options = {
      ...o,
      ...this.options,
      ...ut(n)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...o.interpolation,
      ...this.options.interpolation
    }), n.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = n.keySeparator), n.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = n.nsSeparator);
    function a(u) {
      return u ? typeof u == "function" ? new u() : u : null;
    }
    if (!this.options.isClone) {
      this.modules.logger ? N.init(a(this.modules.logger), this.options) : N.init(null, this.options);
      let u;
      this.modules.formatter ? u = this.modules.formatter : typeof Intl < "u" && (u = zr);
      const p = new st(this.options);
      this.store = new ot(this.options.resources, this.options);
      const f = this.services;
      f.logger = N, f.resourceStore = this.store, f.languageUtils = p, f.pluralResolver = new Fr(p, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), u && (!this.options.interpolation.format || this.options.interpolation.format === o.interpolation.format) && (f.formatter = a(u), f.formatter.init(f, this.options), this.options.interpolation.format = f.formatter.format.bind(f.formatter)), f.interpolator = new Ir(this.options), f.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, f.backendConnector = new Vr(a(this.modules.backend), f.resourceStore, f, this.options), f.backendConnector.on("*", function(h) {
        for (var m = arguments.length, g = new Array(m > 1 ? m - 1 : 0), _ = 1; _ < m; _++)
          g[_ - 1] = arguments[_];
        e.emit(h, ...g);
      }), this.modules.languageDetector && (f.languageDetector = a(this.modules.languageDetector), f.languageDetector.init && f.languageDetector.init(f, this.options.detection, this.options)), this.modules.i18nFormat && (f.i18nFormat = a(this.modules.i18nFormat), f.i18nFormat.init && f.i18nFormat.init(this)), this.translator = new de(this.services, this.options), this.translator.on("*", function(h) {
        for (var m = arguments.length, g = new Array(m > 1 ? m - 1 : 0), _ = 1; _ < m; _++)
          g[_ - 1] = arguments[_];
        e.emit(h, ...g);
      }), this.modules.external.forEach((h) => {
        h.init && h.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = oe), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      u.length > 0 && u[0] !== "dev" && (this.options.lng = u[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((u) => {
      this[u] = function() {
        return e.store[u](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((u) => {
      this[u] = function() {
        return e.store[u](...arguments), e;
      };
    });
    const l = Y(), c = () => {
      const u = (p, f) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(f), r(p, f);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return u(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, u);
    };
    return this.options.resources || !this.options.initImmediate ? c() : setTimeout(c, 0), l;
  }
  loadResources(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : oe;
    const o = typeof e == "string" ? e : this.language;
    if (typeof e == "function" && (r = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (o && o.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return r();
      const a = [], s = (i) => {
        if (!i || i === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(i).forEach((c) => {
          c !== "cimode" && a.indexOf(c) < 0 && a.push(c);
        });
      };
      o ? s(o) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => s(l)), this.options.preload && this.options.preload.forEach((i) => s(i)), this.services.backendConnector.load(a, this.options.ns, (i) => {
        !i && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), r(i);
      });
    } else
      r(null);
  }
  reloadResources(e, n, r) {
    const o = Y();
    return e || (e = this.languages), n || (n = this.options.ns), r || (r = oe), this.services.backendConnector.reload(e, n, (a) => {
      o.resolve(), r(a);
    }), o;
  }
  use(e) {
    if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && It.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
      for (let n = 0; n < this.languages.length; n++) {
        const r = this.languages[n];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(e, n) {
    var r = this;
    this.isLanguageChangingTo = e;
    const o = Y();
    this.emit("languageChanging", e);
    const a = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, s = (l, c) => {
      c ? (a(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, o.resolve(function() {
        return r.t(...arguments);
      }), n && n(l, function() {
        return r.t(...arguments);
      });
    }, i = (l) => {
      !e && !l && this.services.languageDetector && (l = []);
      const c = typeof l == "string" ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      c && (this.language || a(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(c)), this.loadResources(c, (u) => {
        s(u, c);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? i(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(i) : this.services.languageDetector.detect(i) : i(e), o;
  }
  getFixedT(e, n, r) {
    var o = this;
    const a = function(s, i) {
      let l;
      if (typeof i != "object") {
        for (var c = arguments.length, u = new Array(c > 2 ? c - 2 : 0), p = 2; p < c; p++)
          u[p - 2] = arguments[p];
        l = o.options.overloadTranslationOptionHandler([s, i].concat(u));
      } else
        l = {
          ...i
        };
      l.lng = l.lng || a.lng, l.lngs = l.lngs || a.lngs, l.ns = l.ns || a.ns, l.keyPrefix = l.keyPrefix || r || a.keyPrefix;
      const f = o.options.keySeparator || ".";
      let h;
      return l.keyPrefix && Array.isArray(s) ? h = s.map((m) => `${l.keyPrefix}${f}${m}`) : h = l.keyPrefix ? `${l.keyPrefix}${f}${s}` : s, o.t(h, l);
    };
    return typeof e == "string" ? a.lng = e : a.lngs = e, a.ns = n, a.keyPrefix = r, a;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = n.lng || this.resolvedLanguage || this.languages[0], o = this.options ? this.options.fallbackLng : !1, a = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode") return !0;
    const s = (i, l) => {
      const c = this.services.backendConnector.state[`${i}|${l}`];
      return c === -1 || c === 2;
    };
    if (n.precheck) {
      const i = n.precheck(this, s);
      if (i !== void 0) return i;
    }
    return !!(this.hasResourceBundle(r, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || s(r, e) && (!o || s(a, e)));
  }
  loadNamespaces(e, n) {
    const r = Y();
    return this.options.ns ? (typeof e == "string" && (e = [e]), e.forEach((o) => {
      this.options.ns.indexOf(o) < 0 && this.options.ns.push(o);
    }), this.loadResources((o) => {
      r.resolve(), n && n(o);
    }), r) : (n && n(), Promise.resolve());
  }
  loadLanguages(e, n) {
    const r = Y();
    typeof e == "string" && (e = [e]);
    const o = this.options.preload || [], a = e.filter((s) => o.indexOf(s) < 0 && this.services.languageUtils.isSupportedCode(s));
    return a.length ? (this.options.preload = o.concat(a), this.loadResources((s) => {
      r.resolve(), n && n(s);
    }), r) : (n && n(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e) return "rtl";
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new st(ct());
    return n.indexOf(r.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    return new ee(e, n);
  }
  cloneInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : oe;
    const r = e.forkResourceStore;
    r && delete e.forkResourceStore;
    const o = {
      ...this.options,
      ...e,
      isClone: !0
    }, a = new ee(o);
    return (e.debug !== void 0 || e.prefix !== void 0) && (a.logger = a.logger.clone(e)), ["store", "services", "language"].forEach((i) => {
      a[i] = this[i];
    }), a.services = {
      ...this.services
    }, a.services.utils = {
      hasLoadedNamespace: a.hasLoadedNamespace.bind(a)
    }, r && (a.store = new ot(this.store.data, o), a.services.resourceStore = a.store), a.translator = new de(a.services, o), a.translator.on("*", function(i) {
      for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), u = 1; u < l; u++)
        c[u - 1] = arguments[u];
      a.emit(i, ...c);
    }), a.init(o, n), a.translator.options = o, a.translator.backendConnector.services.utils = {
      hasLoadedNamespace: a.hasLoadedNamespace.bind(a)
    }, a;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const R = ee.createInstance();
R.createInstance = ee.createInstance;
const Hr = R.createInstance;
R.dir;
R.init;
R.loadResources;
R.reloadResources;
R.use;
R.changeLanguage;
R.getFixedT;
R.t;
R.exists;
R.setDefaultNamespace;
R.hasLoadedNamespace;
R.loadNamespaces;
R.loadLanguages;
const Kr = "", qr = {
  "autocomplete.button": "Søg",
  "autocomplete.placeholder": "Hvor skal du hen ?",
  "button.free-signup": "Tilmeld dig gratis",
  "button.validate": "Bekræft",
  "error.characters_max_limit": "Må ikke overstige {{limit}} tegn",
  "error.reload": "Opdater siden",
  "error.return-homepage": "Tilbage til startsiden",
  "error.subtitle": "Denne side kan desværre ikke nås..",
  "error.title": "Der opstod en fejl på siden",
  "errors.unable_to_submit.subtitle": '"Din formular kunne desværre ikke \\nindsendes lige nu. Prøv igen \\nsenere."',
  "errors.unable_to_submit.title": "Ups, vi løb ind i et problem",
  no_result: Kr
}, Jr = "Når du har forhåndsgodkendt  dette boligbytte, skal din byttepartner bekræfte det. Byttepartneren har {nbDays} dage til at bekræfte boligbyttet (indtil {date}). Ellers vil din forhåndsgodkendelse udløbe, og du bliver nødt til at forhåndsgodkende boligbyttet igen.", Gr = "Dobbelt booking (via en anden platform)", Wr = "Familieproblemer", Zr = "Helbredsproblemer", Yr = "Skader i hjemmet", Qr = "Flytning", Xr = "Du skal angive årsagerne til, at du vil annullere boligbyttet.", eo = "Andre", to = "Transportproblemer", no = "Tillidsproblem", ro = "Arbejdsrelateret", oo = "Du er nødt til at indtaste en årsag", ao = {
  "cancellation-page.cancel-exchange": "Annuller boligbyttet",
  "cancellation-page.continue-cancellation": "Fortsæt annulleringen",
  "cancellation-page.keep-exchange": "Behold mit boligbytte",
  "cancellation-page.reason_step.checboxes_label": "Vælg hovedårsagen til din annullering:",
  "cancellation-page.reason_step.comment_placeholder": "Skriv årsagen til din annullering her.",
  "cancellation-page.reason_step.error": "Du er nødt til at indtaste en årsag",
  "cancellation-page.reason_step.title": "Hvorfor er du nødt til at annullere?",
  "cancellation-page.warning-step.first-warning": "Husk, at annullering af dit boligbytte kan have en negativ indvirkning på din byttepartner, som måske allerede har lavet rejseplaner!",
  "cancellation-page.warning-step.second-warning": "Vigtigt: I tilfælde af for mange uberettigede aflysninger som vært, kan din konto blive taget offline. Og som gæst får du muligvis ikke alle dine GuestPoints tilbage.",
  pre_approval_modal_expiration_description: Jr,
  reasons_for_cancellation_double_booking_rental: Gr,
  reasons_for_cancellation_family_issues: Wr,
  reasons_for_cancellation_health_issues: Zr,
  reasons_for_cancellation_home_damage: Yr,
  reasons_for_cancellation_moving: Qr,
  reasons_for_cancellation_needed: Xr,
  reasons_for_cancellation_other: eo,
  reasons_for_cancellation_transportation_issues: to,
  reasons_for_cancellation_trust_issues: no,
  reasons_for_cancellation_work_related: ro,
  reasons_other_comment_needed: oo
}, so = "", io = {
  "autocomplete.button": "Suchen",
  "autocomplete.placeholder": "Wo gehst du hin ?",
  "button.free-signup": "Kostenlos anmelden",
  "button.validate": "Bestätigen",
  "error.characters_max_limit": "Darf {{limit}} Zeichen nicht überschreiten",
  "error.reload": "Aktualisieren Sie diese Seite",
  "error.return-homepage": "Zurück zur Startseite",
  "error.subtitle": "Leider ist diese Seite nicht erreichbar.",
  "error.title": "Es ist ein Fehler auf der Seite aufgetreten.",
  "errors.unable_to_submit.subtitle": "Leider konnte Ihr Formular im Moment nicht abgeschickt werden. Bitte versuchen Sie es später noch einmal.",
  "errors.unable_to_submit.title": "Hoppla, wir haben ein Problem",
  no_result: so
}, lo = "Nachdem Sie diesen Haustausch vorläufig bestätigt haben, muss Ihr Tauschpartner ihn finalisieren. Dazu hat Ihr Partner {nbDays} Tage Zeit (bis {date}). Nach Ablauf dieser Frist erlischt Ihre Vorabbestätigung und Sie müssen den Haustausch erneut vorläufig bestätigen.", co = "Doppelbuchung (über eine andere Plattform)", uo = "Familiäre Gründe", fo = "Gesundheitliche Probleme", po = "Schäden an der Unterkunft", ho = "Umzug", go = "Sie müssten bitte die Gründe für Ihre Annullierung angeben.", mo = "Andere", _o = "Probleme bei der An-/Abreise", bo = "Vertrauensprobleme", yo = "Arbeitsbedingte Gründe", vo = "Sie müssen einen Grund angeben", wo = {
  "cancellation-page.cancel-exchange": "Den Tausch stornieren",
  "cancellation-page.continue-cancellation": "Stornierung fortsetzen",
  "cancellation-page.keep-exchange": "Meinen Haustausch beibehalten",
  "cancellation-page.reason_step.checboxes_label": "Wählen Sie den Hauptgrund für Ihre Stornierung aus:",
  "cancellation-page.reason_step.comment_placeholder": "Bitte geben Sie hier den Grund für Ihre Stornierung an",
  "cancellation-page.reason_step.error": "Sie müssen einen Grund angeben",
  "cancellation-page.reason_step.title": "Warum müssen Sie stornieren?",
  "cancellation-page.warning-step.first-warning": "Beachten Sie, dass die Stornierung Ihres Haustauschs negative Auswirkungen auf Ihre Tauschpartner haben könnte, die möglicherweise bereits Reisepläne gemacht haben!",
  "cancellation-page.warning-step.second-warning": "Wichtig: Zu viele ungerechtfertigte Stornierungen können dazu führen, dass Ihr Konto als Gastgeber*in offline gestellt wird. Als Gast*in können Ihnen möglicherweise nicht alle Ihre GuestPoints zurückerstattet werden.",
  pre_approval_modal_expiration_description: lo,
  reasons_for_cancellation_double_booking_rental: co,
  reasons_for_cancellation_family_issues: uo,
  reasons_for_cancellation_health_issues: fo,
  reasons_for_cancellation_home_damage: po,
  reasons_for_cancellation_moving: ho,
  reasons_for_cancellation_needed: go,
  reasons_for_cancellation_other: mo,
  reasons_for_cancellation_transportation_issues: _o,
  reasons_for_cancellation_trust_issues: bo,
  reasons_for_cancellation_work_related: yo,
  reasons_other_comment_needed: vo
}, xo = "No result", So = {
  "autocomplete.button": "Search",
  "autocomplete.placeholder": "Where are you going ?",
  "button.free-signup": "Sign up for free",
  "button.validate": "Validate",
  "error.characters_max_limit": "Must not exceed {{limit}} characters",
  "error.reload": "Refresh this page",
  "error.return-homepage": "Return to home page",
  "error.subtitle": "Unfortunately this page can't be reached.",
  "error.title": "An error occurred on the page",
  "errors.unable_to_submit.subtitle": "Unfortunately your form couldn't be submitted right now. Please try again later.",
  "errors.unable_to_submit.title": "Oops, we've hit a problem",
  no_result: xo
}, ko = "After you pre-approve this exchange, your exchange partner will need to finalize it. They have {nbDays} days to finalize the exchange (until {date}). Otherwise, your pre-approval will expire and you will have to preapprove the exchange again.", Oo = "Double booking (via another platform)", Ro = "Family issue", Eo = "Health issue", $o = "Home damage", jo = "Moving home", Po = "You need to indicate the reasons for your cancellation.", Ao = "Other", Lo = "Transport issue", Co = "Trust issue", No = "Work related", To = "You need to enter a reason", Do = {
  "cancellation-page.cancel-exchange": "Cancel the exchange",
  "cancellation-page.continue-cancellation": "Continue cancellation",
  "cancellation-page.keep-exchange": "Keep my exchange",
  "cancellation-page.reason_step.checboxes_label": "Select the main reason for your cancellation:",
  "cancellation-page.reason_step.comment_placeholder": "Write the reason for your cancellation here",
  "cancellation-page.reason_step.error": "You need to enter a reason",
  "cancellation-page.reason_step.title": "Why do you need to cancel?",
  "cancellation-page.warning-step.first-warning": "Remember that cancelling your exchange could impact negatively on your exchange partner, who might already have made plans!",
  "cancellation-page.warning-step.second-warning": "Important: In case of excessive unjustified cancellations as a host, your account may be taken offline. And as a guest, you may not have all your GuestPoints returned to you.",
  pre_approval_modal_expiration_description: ko,
  reasons_for_cancellation_double_booking_rental: Oo,
  reasons_for_cancellation_family_issues: Ro,
  reasons_for_cancellation_health_issues: Eo,
  reasons_for_cancellation_home_damage: $o,
  reasons_for_cancellation_moving: jo,
  reasons_for_cancellation_needed: Po,
  reasons_for_cancellation_other: Ao,
  reasons_for_cancellation_transportation_issues: Lo,
  reasons_for_cancellation_trust_issues: Co,
  reasons_for_cancellation_work_related: No,
  reasons_other_comment_needed: To
}, Fo = "", Io = {
  "autocomplete.button": "Search",
  "autocomplete.placeholder": "Where are you going ?",
  "button.free-signup": "Sign up for free",
  "button.validate": "",
  "error.characters_max_limit": "Must not exceed {{limit}} characters",
  "error.reload": "Refresh this page",
  "error.return-homepage": "Return to home page",
  "error.subtitle": "Unfortunately this page can't be reached.",
  "error.title": "An error occurred on the page",
  "errors.unable_to_submit.subtitle": "",
  "errors.unable_to_submit.title": "",
  no_result: Fo
}, Uo = "After you pre-approve this exchange, your exchange partner will need to finalize it. They have {nbDays} days to finalize the exchange (until {date}). Otherwise, your pre-approval will expire and you will have to preapprove the exchange again.", zo = "Double booking (via another platform)", Bo = "Family issue", Vo = "Health issue", Mo = "Home damage", Ho = "Moving home", Ko = "", qo = "", Jo = "Transport issue", Go = "Trust issue", Wo = "Work related", Zo = "", Yo = {
  "cancellation-page.cancel-exchange": "Cancel the exchange",
  "cancellation-page.continue-cancellation": "Continue cancellation",
  "cancellation-page.keep-exchange": "Keep my exchange",
  "cancellation-page.reason_step.checboxes_label": "Select the main reason for your cancellation:",
  "cancellation-page.reason_step.comment_placeholder": "",
  "cancellation-page.reason_step.error": "You need to enter a reason",
  "cancellation-page.reason_step.title": "Why do you need to cancel?",
  "cancellation-page.warning-step.first-warning": "Remember that cancelling your exchange could impact negatively on your exchange partner, who might already have made plans!",
  "cancellation-page.warning-step.second-warning": "Important: In case of excessive unjustified cancellations as a host, your account may be taken offline. And as a guest, you may not have all your GuestPoints returned to you.",
  pre_approval_modal_expiration_description: Uo,
  reasons_for_cancellation_double_booking_rental: zo,
  reasons_for_cancellation_family_issues: Bo,
  reasons_for_cancellation_health_issues: Vo,
  reasons_for_cancellation_home_damage: Mo,
  reasons_for_cancellation_moving: Ho,
  reasons_for_cancellation_needed: Ko,
  reasons_for_cancellation_other: qo,
  reasons_for_cancellation_transportation_issues: Jo,
  reasons_for_cancellation_trust_issues: Go,
  reasons_for_cancellation_work_related: Wo,
  reasons_other_comment_needed: Zo
}, Qo = "", Xo = {
  "autocomplete.button": "Buscar",
  "autocomplete.placeholder": "¿Adónde vas?",
  "button.free-signup": "Regístrate gratis",
  "button.validate": "Validar",
  "error.characters_max_limit": "No puedes superar los {{limit}} caracteres",
  "error.reload": "Actualizar esta página",
  "error.return-homepage": "Volver a la página de inicio",
  "error.subtitle": "Lo sentimos, pero no se puede acceder a esta página.",
  "error.title": "Se ha producido un error en la página",
  "errors.unable_to_submit.subtitle": "Lo sentimos, se ha producido un error al enviar el formulario. Por favor, vuelve a intentarlo más tarde.",
  "errors.unable_to_submit.title": "¡Vaya! Algo ha fallado.",
  no_result: Qo
}, ea = "Después de preaprobar este intercambio, tus compañeros de intercambio tendrán que registrarlo. Tienes {nbDays} días para registrar el intercambio (hasta el {date}). De lo contrario, la preaprobación caducará y tendrás que volver a preaprobar el intercambio.", ta = "Reserva doble (otra plataforma)", na = "Asuntos familiares", ra = "Temas de salud", oa = "Daños en la casa", aa = "Mudanza", sa = "Por favor, indica las razones de la cancelación", ia = "Otro", la = "Problemas con el transporte", ca = "Temas de confianza", ua = "Asuntos laborales", fa = "Debes introducir un motivo", da = {
  "cancellation-page.cancel-exchange": "Cancelar el intercambio",
  "cancellation-page.continue-cancellation": "Continuar con la cancelación",
  "cancellation-page.keep-exchange": "Mantener el intercambio",
  "cancellation-page.reason_step.checboxes_label": "Selecciona el motivo principal de la cancelación:",
  "cancellation-page.reason_step.comment_placeholder": "",
  "cancellation-page.reason_step.error": "Debes introducir un motivo",
  "cancellation-page.reason_step.title": "¿Por qué quieres cancelar el intercambio?",
  "cancellation-page.warning-step.first-warning": "No olvides que cancelar el intercambio puede afectar a tus compañeros de intercambio, que seguramente han hecho planes.",
  "cancellation-page.warning-step.second-warning": "Importante: un exceso de cancelaciones injustificadas por parte de los anfitriones puede resultar en la desactivación de su cuenta y, por parte de los invitados, puede implicar que no se recuperen todos los GuestPoints.",
  pre_approval_modal_expiration_description: ea,
  reasons_for_cancellation_double_booking_rental: ta,
  reasons_for_cancellation_family_issues: na,
  reasons_for_cancellation_health_issues: ra,
  reasons_for_cancellation_home_damage: oa,
  reasons_for_cancellation_moving: aa,
  reasons_for_cancellation_needed: sa,
  reasons_for_cancellation_other: ia,
  reasons_for_cancellation_transportation_issues: la,
  reasons_for_cancellation_trust_issues: ca,
  reasons_for_cancellation_work_related: ua,
  reasons_other_comment_needed: fa
}, pa = "", ha = {
  "autocomplete.button": "Rechercher",
  "autocomplete.placeholder": "Où allez-vous ?",
  "button.free-signup": "Inscrivez-vous gratuitement",
  "button.validate": "Valider",
  "error.characters_max_limit": "Ne doit pas dépasser {{limit}} caractères",
  "error.reload": "Actualiser la page",
  "error.return-homepage": "Retour à la page d'accueil",
  "error.subtitle": "Malheureusement, il y a un problème avec cette page.",
  "error.title": "Une erreur s'est produite sur la page",
  "errors.unable_to_submit.subtitle": "Malheureusement, votre réponse n'a pas pu être enregistrée. Merci de réessayer plus tard !",
  "errors.unable_to_submit.title": "Oups, on dirait bien qu'il y a un problème !",
  no_result: pa
}, ga = "Après cette pré-approbation, votre partenaire d'échange disposera de {nbDays} jour(s) pour le finaliser (jusqu'au {date}). Sinon, votre pré-approbation expirera et vous devrez pré-approuver l'échange de nouveau.", ma = "Double réservation (via une autre plateforme)", _a = "Imprévu familial", ba = "Problème de santé", ya = "Dégâts à mon domicile", va = "Déménagement", wa = "Vous devez indiquer les raisons de votre annulation.", xa = "Autre", Sa = "Problème de transport", ka = "Problème de confiance", Oa = "Imprévu professionnel", Ra = "Vous devez saisir un motif", Ea = {
  "cancellation-page.cancel-exchange": "Annuler l'échange",
  "cancellation-page.continue-cancellation": "Poursuivre l'annulation",
  "cancellation-page.keep-exchange": "Conserver mon échange",
  "cancellation-page.reason_step.checboxes_label": "Sélectionnez la raison principale de votre annulation :",
  "cancellation-page.reason_step.comment_placeholder": "Indiquez la raison de votre annulation juste ici",
  "cancellation-page.reason_step.error": "Vous devez saisir un motif",
  "cancellation-page.reason_step.title": "Pourquoi devez-vous annuler ?",
  "cancellation-page.warning-step.first-warning": "N'oubliez pas que l'annulation de votre échange peut avoir un impact négatif sur votre partenaire d'échange, qui a peut-être déjà planifié son voyage !",
  "cancellation-page.warning-step.second-warning": "Important : Face à un nombre excessif d'annulations injustifiées en tant qu'hôte, votre compte pourrait être mis hors ligne et, en tant qu'invité-e, vous pourriez ne pas récupérer l'intégralité de vos GuestPoints.",
  pre_approval_modal_expiration_description: ga,
  reasons_for_cancellation_double_booking_rental: ma,
  reasons_for_cancellation_family_issues: _a,
  reasons_for_cancellation_health_issues: ba,
  reasons_for_cancellation_home_damage: ya,
  reasons_for_cancellation_moving: va,
  reasons_for_cancellation_needed: wa,
  reasons_for_cancellation_other: xa,
  reasons_for_cancellation_transportation_issues: Sa,
  reasons_for_cancellation_trust_issues: ka,
  reasons_for_cancellation_work_related: Oa,
  reasons_other_comment_needed: Ra
}, $a = "", ja = {
  "autocomplete.button": "Pretražite",
  "autocomplete.placeholder": "Gdje ideš ?",
  "button.free-signup": "Prijavite se besplatno",
  "button.validate": "Potvrdite",
  "error.characters_max_limit": "Ne smije biti dulje od {{limit}} znakova",
  "error.reload": "Osvježite stranicu",
  "error.return-homepage": "Vratite se na početnu stranicu",
  "error.subtitle": "Nažalost ne može se pristupiti ovoj stranici.",
  "error.title": "Došlo je do greške na stranici.",
  "errors.unable_to_submit.subtitle": "Nažalost, Vaš obrazac trenutačno ne može biti predan. Molimo da kasnije pokušate ponovno.",
  "errors.unable_to_submit.title": "Ups, imamo problem",
  no_result: $a
}, Pa = "Nakon što unaprijed odobrite ovu zamjenu, Vaš partner za zamjenu ju mora finalizirati. Za to ima {nbDays} dana (do {date}). Ako ne, Vaše će prethodno odobrenje isteći i trebat ćete ponovno prethodno odobriti zamjenu.", Aa = "Dvostruka rezervacija (druga platforma)", La = "Obiteljski problemi", Ca = "Zdravstveni problemi", Na = "Oštećenje doma", Ta = "Preseljenje", Da = "Morate navesti razloge otkazivanja", Fa = "Ostalo", Ia = "Problemi s prijevozom", Ua = "Nepovjerenje", za = "Poslovni problemi", Ba = "Trebate unijeti razlog", Va = {
  "cancellation-page.cancel-exchange": "Otkažite zamjenu",
  "cancellation-page.continue-cancellation": "Nastavite s otkazivanjem",
  "cancellation-page.keep-exchange": "Zadržite svoju zamjenu",
  "cancellation-page.reason_step.checboxes_label": "Odaberite glavni razlog zašto otkazujete:",
  "cancellation-page.reason_step.comment_placeholder": "Ovdje unesite razlog otkazivanja zamjene",
  "cancellation-page.reason_step.error": "Trebate unijeti razlog",
  "cancellation-page.reason_step.title": "Zašto trebate otkazati?",
  "cancellation-page.warning-step.first-warning": "Vodite računa o tome da otkazivanje zamjene može negativno utjecati na Vašeg partnera za zamjenu koji je već možda napravio planove za putovanje!",
  "cancellation-page.warning-step.second-warning": "Važno: U slučaju pretjeranih neopradanih otkazivanja u svojstvu domaćina, Vaš dom može biti uklonjen s interneta. A kao gost, možda nećete dobiti natrag svoje GuestPoints.",
  pre_approval_modal_expiration_description: Pa,
  reasons_for_cancellation_double_booking_rental: Aa,
  reasons_for_cancellation_family_issues: La,
  reasons_for_cancellation_health_issues: Ca,
  reasons_for_cancellation_home_damage: Na,
  reasons_for_cancellation_moving: Ta,
  reasons_for_cancellation_needed: Da,
  reasons_for_cancellation_other: Fa,
  reasons_for_cancellation_transportation_issues: Ia,
  reasons_for_cancellation_trust_issues: Ua,
  reasons_for_cancellation_work_related: za,
  reasons_other_comment_needed: Ba
}, Ma = "", Ha = {
  "autocomplete.button": "Ricerca",
  "autocomplete.placeholder": "Dove stai andando?",
  "button.free-signup": "Iscriviti gratis",
  "button.validate": "Convalida",
  "error.characters_max_limit": "Non deve superare i {{limit}} caratteri",
  "error.reload": "Aggiorna la pagina",
  "error.return-homepage": "Ritorna alla home page",
  "error.subtitle": "Si è verificato un errore e non è stato possibile caricare questa pagina.",
  "error.title": "Si è verificato un errore nella pagina",
  "errors.unable_to_submit.subtitle": "Errore durante l'invio del modulo. Per favore riprova più tardi.",
  "errors.unable_to_submit.title": "Errore: è impossibile inviare",
  no_result: Ma
}, Ka = "Dopo aver pre-approvato questo scambio, il tuo partner di scambio dovrà finalizzarlo. Avrà tempo {nbDays} giorni per finalizzare lo scambio (fino al giorno {date}). In caso contrario, la tua pre-approvazione scadrà e dovrai pre-approvare lo scambio nuovamente.", qa = "Doppia prenotazione (con un'altra piattaforma)", Ja = "Ragioni familiari", Ga = "Motivi di salute", Wa = "Danni alla proprietà", Za = "Trasferimento", Ya = "È necessario indicare i motivi per la cancellazione.", Qa = "Altro", Xa = "Problemi di trasporto", es = "Problemi di fiducia", ts = "Motivi legati al lavoro", ns = "È necessario inserire un motivo", rs = {
  "cancellation-page.cancel-exchange": "Annulla lo scambio",
  "cancellation-page.continue-cancellation": "Continua con la cancellazione",
  "cancellation-page.keep-exchange": "Mantieni il mio scambio",
  "cancellation-page.reason_step.checboxes_label": "Seleziona il motivo principale della tua cancellazione:",
  "cancellation-page.reason_step.comment_placeholder": "Inserisci qui la ragione della cancellazione",
  "cancellation-page.reason_step.error": "È necessario inserire un motivo",
  "cancellation-page.reason_step.title": "Perché devi annullare?",
  "cancellation-page.warning-step.first-warning": "Ricorda che annullare il tuo scambio può avere un impatto negativo sul tuo partner di scambio, che potrebbe già aver pianificato il viaggio!",
  "cancellation-page.warning-step.second-warning": "Importante: In caso di eccessive cancellazioni ingiustificate in qualità di host, il tuo account potrebbe essere disattivato. E come ospite, potresti non recuperare tutti i tuoi GuestPoints.",
  pre_approval_modal_expiration_description: Ka,
  reasons_for_cancellation_double_booking_rental: qa,
  reasons_for_cancellation_family_issues: Ja,
  reasons_for_cancellation_health_issues: Ga,
  reasons_for_cancellation_home_damage: Wa,
  reasons_for_cancellation_moving: Za,
  reasons_for_cancellation_needed: Ya,
  reasons_for_cancellation_other: Qa,
  reasons_for_cancellation_transportation_issues: Xa,
  reasons_for_cancellation_trust_issues: es,
  reasons_for_cancellation_work_related: ts,
  reasons_other_comment_needed: ns
}, os = "", as = {
  "autocomplete.button": "Søk",
  "autocomplete.placeholder": "Hvor skal du ?",
  "button.free-signup": "Registrer deg gratis",
  "button.validate": "Bekreft",
  "error.characters_max_limit": "Kan ikke overstige {{limit}} tegn",
  "error.reload": "Oppdater siden",
  "error.return-homepage": "Gå tilbake til startsiden",
  "error.subtitle": "Denne siden kan dessverre ikke nås.",
  "error.title": "En feil har oppstått på siden",
  "errors.unable_to_submit.subtitle": "Skjemaet ditt kunne dessverre ikke sendes inn akkurat nå. Vennligst prøv igjen senere.",
  "errors.unable_to_submit.title": "Oops, det har oppstått et problem",
  no_result: os
}, ss = "Etter at du har forhåndsgodkjent dette boligbyttet må din boligbyttepartner ferdigstille det. De har {nbDays} dager på seg til å ferdigstille boligbyttet (frem til {date}). Om ikke vil forhåndsgodkjenningen din utløpe, og du må forhåndsgodkjenne boligbyttet på nytt.", is = "Dobbelbooking (via en annen plattform)", ls = "Famileproblemer", cs = "Helseproblemer", us = "Skade på boligen", fs = "Flytting", ds = "Du må angi årsakene til avbestillingen.", ps = "Annet", hs = "Transportproblemer", gs = "Tillitsbrudd", ms = "Arbeidsrelatert", _s = "Du må oppgi en grunn", bs = {
  "cancellation-page.cancel-exchange": "Kanseller boligbyttet",
  "cancellation-page.continue-cancellation": "Fortsett kansellering",
  "cancellation-page.keep-exchange": "Behold boligbyttet",
  "cancellation-page.reason_step.checboxes_label": "Velg hovedårsaken for din kansellering:",
  "cancellation-page.reason_step.comment_placeholder": "Oppgi årsaken for din kansellering her",
  "cancellation-page.reason_step.error": "Du må oppgi en grunn",
  "cancellation-page.reason_step.title": "Hvorfor ønsker du å kansellere?",
  "cancellation-page.warning-step.first-warning": "Husk at det å kansellere boligbyttet kan ha en negativ innvirkning på din boligbyttepartner, som kanskje allerede har lagt reiseplaner!",
  "cancellation-page.warning-step.second-warning": "Viktig: Dersom du kansellerer et boligbytte som vert uten gyldig grunn kan din konto bli sperret. Som gjest kan konsekvensen være at du ikke får refundert alle dine GuestPoints.",
  pre_approval_modal_expiration_description: ss,
  reasons_for_cancellation_double_booking_rental: is,
  reasons_for_cancellation_family_issues: ls,
  reasons_for_cancellation_health_issues: cs,
  reasons_for_cancellation_home_damage: us,
  reasons_for_cancellation_moving: fs,
  reasons_for_cancellation_needed: ds,
  reasons_for_cancellation_other: ps,
  reasons_for_cancellation_transportation_issues: hs,
  reasons_for_cancellation_trust_issues: gs,
  reasons_for_cancellation_work_related: ms,
  reasons_other_comment_needed: _s
}, ys = "", vs = {
  "autocomplete.button": "Zoeken",
  "autocomplete.placeholder": "Waar ga je naar toe ?",
  "button.free-signup": "Meld je gratis aan",
  "button.validate": "Bevestigen",
  "error.characters_max_limit": "Mag de {{limit}} karakters niet overschrijden",
  "error.reload": "Deze pagina vernieuwen ",
  "error.return-homepage": "Terug naar de startpagina",
  "error.subtitle": "Helaas kon deze pagina niet gevonden worden.",
  "error.title": "Er is een fout opgetreden op de pagina",
  "errors.unable_to_submit.subtitle": "Helaas kon het formulier niet verzonden worden. Probeer het later nog eens.",
  "errors.unable_to_submit.title": "Oeps... het is niet gelukt om het formulier te verzenden.",
  no_result: ys
}, ws = "Nadat je de uitwisseling hebt goedgekeurd, moet je uitwisselingspartner deze bevestigen. Hij of zij heeft {nbDays} dagen de tijd om dit te doen (tot {date}). Anders vervalt je voorlopige goedkeuring en moet je de uitwisseling opnieuw goedkeuren.", xs = "Dubbele boeking (via een ander platform)", Ss = "Familiale redenen", ks = "Gezondheidsproblemen", Os = "Schade aan het huis", Rs = "Verhuis", Es = "U dient aan te geven in de redenen voor uw annulering.", $s = "Andere", js = "Problemen met het transport", Ps = "Vertrouwenskwestie", As = "Werkgerelateerde redenen", Ls = "Je moet een reden opgeven", Cs = {
  "cancellation-page.cancel-exchange": "Annuleer de uitwisseling",
  "cancellation-page.continue-cancellation": "Doorgaan met annuleren",
  "cancellation-page.keep-exchange": "Mijn uitwisseling behouden",
  "cancellation-page.reason_step.checboxes_label": "Selecteer de hoofdreden voor je annulering:",
  "cancellation-page.reason_step.comment_placeholder": "Schrijf hier de reden van de annulering.",
  "cancellation-page.reason_step.error": "Je moet een reden opgeven",
  "cancellation-page.reason_step.title": "Waarom moet je annuleren?",
  "cancellation-page.warning-step.first-warning": "Vergeet niet dat het annuleren van je uitwisseling negatieve gevolgen kan hebben voor je uitwisselingspartner, die misschien al reisplannen heeft gemaakt!",
  "cancellation-page.warning-step.second-warning": "Belangrijk: Als je als gastheer/-vrouw te vaak onterecht annuleert, kan je account offline worden gehaald. En als gast kan het zijn dat je niet al je GuestPoints terugkrijgt.",
  pre_approval_modal_expiration_description: ws,
  reasons_for_cancellation_double_booking_rental: xs,
  reasons_for_cancellation_family_issues: Ss,
  reasons_for_cancellation_health_issues: ks,
  reasons_for_cancellation_home_damage: Os,
  reasons_for_cancellation_moving: Rs,
  reasons_for_cancellation_needed: Es,
  reasons_for_cancellation_other: $s,
  reasons_for_cancellation_transportation_issues: js,
  reasons_for_cancellation_trust_issues: Ps,
  reasons_for_cancellation_work_related: As,
  reasons_other_comment_needed: Ls
}, Ns = "", Ts = {
  "autocomplete.button": "Procurar",
  "autocomplete.placeholder": "Para onde vai ?",
  "button.free-signup": "Filie-se gratuitamente",
  "button.validate": "Validar",
  "error.characters_max_limit": "Não deve ser superior a {{limit}} caracteres",
  "error.reload": "Atualizar esta página",
  "error.return-homepage": "Voltar à página inicial",
  "error.subtitle": "Infelizmente, não foi possível aceder a esta página.",
  "error.title": "Ocorreu um erro na página",
  "errors.unable_to_submit.subtitle": "Infelizmente, não foi possível submeter o formulário. Tente novamente mais tarde.",
  "errors.unable_to_submit.title": "Ups, ocorreu um problema!",
  no_result: Ns
}, Ds = "Após pré-aprovar esta troca, o seu parceiro de troca terá de a finalizar e terá {nbDays} dias para o fazer (até {date}). Caso contrário, a sua pré-aprovação irá expirar e terá de voltar a pré-aprovar a troca.", Fs = "Reserva dupla (outra plataforma)", Is = "Motivos familiares", Us = "Motivos de saúde", zs = "Danos na propriedade", Bs = "Mudanças", Vs = "Você precisa indicar os motivos do cancelamento.", Ms = "Outro", Hs = "Problemas de transporte", Ks = "Problemas de confiança", qs = "Motivos laborais", Js = "É obrigatório introduzir um motivo", Gs = {
  "cancellation-page.cancel-exchange": "Cancelar a troca",
  "cancellation-page.continue-cancellation": "Continuar com o cancelamento",
  "cancellation-page.keep-exchange": "Manter a minha troca",
  "cancellation-page.reason_step.checboxes_label": "Selecione o motivo principal para o cancelamento:",
  "cancellation-page.reason_step.comment_placeholder": "Escreva aqui o motivo do cancelamento",
  "cancellation-page.reason_step.error": "É obrigatório introduzir um motivo",
  "cancellation-page.reason_step.title": "Por que motivo precisa de cancelar?",
  "cancellation-page.warning-step.first-warning": "Lembre-se que cancelar a sua troca pode ter um impacto negativo para o seu parceiro de troca, que pode já ter feito planos de viagem!",
  "cancellation-page.warning-step.second-warning": "Importante: Caso tenha demasiados cancelamentos injustificados como anfitrião, a sua conta poderá ser colocada offline. Caso isto aconteça enquanto convidado, poderá não receber todos os seus GuestPoints de volta.",
  pre_approval_modal_expiration_description: Ds,
  reasons_for_cancellation_double_booking_rental: Fs,
  reasons_for_cancellation_family_issues: Is,
  reasons_for_cancellation_health_issues: Us,
  reasons_for_cancellation_home_damage: zs,
  reasons_for_cancellation_moving: Bs,
  reasons_for_cancellation_needed: Vs,
  reasons_for_cancellation_other: Ms,
  reasons_for_cancellation_transportation_issues: Hs,
  reasons_for_cancellation_trust_issues: Ks,
  reasons_for_cancellation_work_related: qs,
  reasons_other_comment_needed: Js
}, Ws = "", Zs = {
  "autocomplete.button": "Sök",
  "autocomplete.placeholder": "Vart ska du ?",
  "button.free-signup": "Registrera dig gratis",
  "button.validate": "Godkänn",
  "error.characters_max_limit": "Får inte överskrida {{limit}} tecken",
  "error.reload": "Ladda om sidan",
  "error.return-homepage": "Gå tillbaka till startsidan",
  "error.subtitle": "Tyvärr kan inte den här sidan nås.",
  "error.title": "Ett fel uppstod på sidan",
  "errors.unable_to_submit.subtitle": "Tyvärr kunde inte ditt formulär skickas in just nu. Vänligen försök igen senare.",
  "errors.unable_to_submit.title": "Hoppsan, vi har stött på ett problem",
  no_result: Ws
}, Ys = "Efter att du har förgodkänt det här hembytet behöver din hembytespartner bekräfta det. Hen har {nbDays} dagar på sig att bekräfta det (till {date}). Annars kommer ditt förgodkännande att löpa ut och du behöver förgodkänna hembytet igen.", Qs = "Dubbelbokning (annan plattform)", Xs = "Familjeproblem", ei = "Hälsoproblem", ti = "Skada i hemmet", ni = "Flytt", ri = "Du måste ange orsaken till din avbokning.", oi = "Övrigt", ai = "Transportproblem", si = "Bristande förtroende", ii = "Arbetsrelaterat", li = "Du behöver ange en anledning", ci = {
  "cancellation-page.cancel-exchange": "Avboka hembytet",
  "cancellation-page.continue-cancellation": "Fortsätt avbokning",
  "cancellation-page.keep-exchange": "Behåll mitt hembyte",
  "cancellation-page.reason_step.checboxes_label": "Välj huvudanledningen till din avbokning:",
  "cancellation-page.reason_step.comment_placeholder": "Ange anledningen till din avbokning här.",
  "cancellation-page.reason_step.error": "Du behöver ange en anledning",
  "cancellation-page.reason_step.title": "Varför behöver du avboka?",
  "cancellation-page.warning-step.first-warning": "Kom ihåg att ifall du avbokar ditt hembyte kan det ha en negativ inverkan på din hembytespartner, som kanske redan har planerat sin resa!",
  "cancellation-page.warning-step.second-warning": "Viktigt: Vid överdrivna och omotiverade avbokningar som värd kan ditt konto tas offline. Och som gäst kanske inte alla dina GuestPoints återgäldas till dig.",
  pre_approval_modal_expiration_description: Ys,
  reasons_for_cancellation_double_booking_rental: Qs,
  reasons_for_cancellation_family_issues: Xs,
  reasons_for_cancellation_health_issues: ei,
  reasons_for_cancellation_home_damage: ti,
  reasons_for_cancellation_moving: ni,
  reasons_for_cancellation_needed: ri,
  reasons_for_cancellation_other: oi,
  reasons_for_cancellation_transportation_issues: ai,
  reasons_for_cancellation_trust_issues: si,
  reasons_for_cancellation_work_related: ii,
  reasons_other_comment_needed: li
}, ui = "en", Ut = Hr({
  fallbackLng: ui,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  resources: {
    da: {
      common: qr,
      conversations: ao
    },
    de: {
      common: io,
      conversations: wo
    },
    en: {
      conversations: Do,
      common: So
    },
    en_US: {
      conversations: Yo,
      common: Io
    },
    es: {
      conversations: da,
      common: Xo
    },
    fr: {
      conversations: Ea,
      common: ha
    },
    hr: {
      conversations: Va,
      common: ja
    },
    it: {
      conversations: rs,
      common: Ha
    },
    nb: {
      conversations: bs,
      common: as
    },
    nl: {
      conversations: Cs,
      common: vs
    },
    pt: {
      conversations: Gs,
      common: Ts
    },
    sv: {
      conversations: ci,
      common: Zs
    }
  }
});
Ut.init();
const Li = Ut, fi = 3, di = (t, e) => {
  const n = typeof e.guest.id == "string" ? parseInt(e.guest.id, 10) : e.guest.id, r = typeof e.host.id == "string" ? parseInt(e.host.id, 10) : e.host.id, o = t.id;
  return n === o || r === o;
}, pi = (t, e) => t.getFullYear() === e.getFullYear() && t.getMonth() === e.getMonth() && t.getDate() === e.getDate(), hi = (t) => {
  const e = /* @__PURE__ */ new Date(), n = new Date(t.start_on);
  return t.status === fi && (pi(e, n) || n > e);
}, Ci = (t, e) => {
  const n = e.exchanges.every(hi);
  return e.exchanges.some((o) => di(t, o)) && n;
}, Ie = (t, e) => t.split(";").map((n) => n.split("=")).filter(([n]) => !e || e.includes(n.trim())).reduce(
  (n, [r, o]) => (n[r.trim()] = o.trim(), n),
  {}
);
async function Ni(t, e) {
  try {
    const n = {}, r = e || Ie(document.cookie, ["access_token", "refresh_token"]);
    return r && (n.Authorization = `Bearer ${r.access_token}`, n.Cookie = Object.keys(r).map((o) => `${o}=${r[o]}`).join("; ")), await be.get(`/exchange/${t}/cancel`, { headers: n });
  } catch {
    throw new Error("Error while getting the conversation informations");
  }
}
async function Ti(t, e, n) {
  try {
    const r = {}, o = Ie(document.cookie, ["access_token", "refresh_token"]);
    return o && (r.Authorization = `Bearer ${o.access_token}`, r.Cookie = Object.keys(o).map((a) => `${a}=${o[a]}`).join("; ")), await be.patch(`/exchange/${t}/cancel`, {
      headers: r,
      data: { cancellationReasonId: +e, comment: n }
    });
  } catch {
    throw new Error("Error while cancelling the conversation");
  }
}
async function Di({ stayTypeId: t, startDate: e, endDate: n, homeId: r, hostId: o, guestId: a, guestNumber: s, content: i }, l) {
  const c = {}, p = (l ? !!(l.access_token && l.refresh_token) : !1) ? l : Ie(document.cookie, ["access_token", "refresh_token"]);
  return p && (c.Authorization = `Bearer ${p.access_token}`, c.Cookie = Object.keys(p).map((f) => `${f}=${p[f]}`).join("; ")), await be.post("/exchange", {
    headers: c,
    data: JSON.stringify({
      stayTypeId: t,
      startDate: e,
      endDate: n,
      homeId: r,
      hostId: o,
      guestId: a,
      guestNumber: s,
      content: i
    })
  });
}
export {
  Di as a,
  Ci as b,
  Ti as c,
  Ni as g,
  be as h,
  Li as i,
  Ie as p,
  Ai as s
};
